/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/api-integration.js":
/*!******************************************!*\
  !*** ./js/components/api-integration.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debounce: () => (/* binding */ debounce),
/* harmony export */   getHeaderSearch: () => (/* binding */ getHeaderSearch),
/* harmony export */   handleApiError: () => (/* binding */ handleApiError),
/* harmony export */   submitAdaptHealthForm: () => (/* binding */ submitAdaptHealthForm)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");

var _window$shopifyVariab2;

var searchUrl = window.Shopify.routes.root + "search?sections=header-search";
var debounce = (func, delay) => {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};
var getHeaderSearch = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (query) {
    try {
      var response = yield axios__WEBPACK_IMPORTED_MODULE_1__["default"].get(searchUrl, {
        params: {
          q: query
        }
      });
      return response.data;
    } catch (e) {
      console.error(e);
      return [];
    }
  });
  return function getHeaderSearch(_x) {
    return _ref.apply(this, arguments);
  };
}();

// Constants for token management
var TOKEN_COOKIE_NAME = 'adapthealth_client_token';
var TOKEN_EXPIRY_COOKIE_NAME = 'adapthealth_client_token_expiry';
var TOKEN_VALIDITY_HOURS = 23;
var TOKEN_VALIDITY_MS = TOKEN_VALIDITY_HOURS * 60 * 60 * 1000;

// Get environment-specific credentials
var getAuthCredentials = () => {
  var _window$shopifyVariab;
  var isStaging = (_window$shopifyVariab = window.shopifyVariables) === null || _window$shopifyVariab === void 0 ? void 0 : _window$shopifyVariab.isStaging;
  return {
    baseURL: isStaging ? "https://nonprodapi.adapthealth.com/use1/qa/exp/auth/v1/" : "https://prod.adapthealth.com/auth/v1/",
    clientId: isStaging ? "c7530cc8e3484bfa9be53a318d9ac2d6" : "",
    clientSecret: isStaging ? "e533DC22a55641EaABAF0C0dDa604b36" : ""
  };
};

// Cookie utility functions
var setCookie = (name, value, hours) => {
  var expires = new Date();
  expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
  document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(expires.toUTCString(), ";path=/;SameSite=Lax");
};
var getCookie = name => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
var deleteCookie = name => {
  document.cookie = "".concat(name, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;");
};

// Create Axios instances
var authClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
  baseURL: getAuthCredentials().baseURL,
  headers: {
    "Content-Type": "text/html"
  }
});
var formsApiClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
  baseURL: (_window$shopifyVariab2 = window.shopifyVariables) !== null && _window$shopifyVariab2 !== void 0 && _window$shopifyVariab2.isStaging ? "https://nonprodapi.adapthealth.com/use1/qa/exp/adapthealth/v1//api/forms" : "https://prod.adapthealth.com/adapthealth/v1/api/forms",
  headers: {
    "Content-Type": "application/json"
  }
});

// Token management functions
var tokenGenerationPromise = null;
var generateClientToken = /*#__PURE__*/function () {
  var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    if (tokenGenerationPromise) {
      return tokenGenerationPromise;
    }
    tokenGenerationPromise = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var _response$data;
        var credentials = getAuthCredentials();
        var response = yield authClient.post("client/token", null, {
          headers: {
            "client_id": credentials.clientId,
            "client_secret": credentials.clientSecret,
            "grant_type": "CLIENT_CREDENTIALS",
            "Accept": "application/json"
          }
        });
        var token = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.access_token;
        if (!token) {
          throw new Error('No access token received from token endpoint');
        }
        return token;
      } catch (error) {
        console.error('Error generating client token:', error);
        throw new Error("Failed to generate client token: ".concat(error.message));
      } finally {
        tokenGenerationPromise = null;
      }
    })();
    return tokenGenerationPromise;
  });
  return function generateClientToken() {
    return _ref2.apply(this, arguments);
  };
}();
var validateClientToken = /*#__PURE__*/function () {
  var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (token) {
    try {
      var _response$data2;
      var credentials = getAuthCredentials();
      var response = yield authClient.get("client/validate", {
        headers: {
          "Authorization": "".concat(token),
          "Accept": "application/json"
        }
      });
      var responseClientId = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.client_id;
      if (responseClientId !== credentials.clientId) {
        console.warn('Token validation failed: clientId mismatch');
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error validating client token:', error);
      return false;
    }
  });
  return function validateClientToken(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var getCachedToken = () => {
  var token = getCookie(TOKEN_COOKIE_NAME);
  var expiry = getCookie(TOKEN_EXPIRY_COOKIE_NAME);
  if (!token || !expiry) {
    return null;
  }
  var now = new Date().getTime();
  var expiryTime = parseInt(expiry, 10);
  if (now >= expiryTime) {
    deleteCookie(TOKEN_COOKIE_NAME);
    deleteCookie(TOKEN_EXPIRY_COOKIE_NAME);
    return null;
  }
  return token;
};
var cacheToken = token => {
  var expiryTime = new Date().getTime() + TOKEN_VALIDITY_MS;
  setCookie(TOKEN_COOKIE_NAME, token, TOKEN_VALIDITY_HOURS);
  setCookie(TOKEN_EXPIRY_COOKIE_NAME, expiryTime.toString(), TOKEN_VALIDITY_HOURS);
};
var getOrRefreshClientToken = /*#__PURE__*/function () {
  var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var token = getCachedToken();
    if (token) {
      var isValid = yield validateClientToken(token);
      if (isValid) {
        return token;
      } else {
        deleteCookie(TOKEN_COOKIE_NAME);
        deleteCookie(TOKEN_EXPIRY_COOKIE_NAME);
        token = null;
      }
    }
    if (!token) {
      token = yield generateClientToken();
      var _isValid = yield validateClientToken(token);
      if (!_isValid) {
        console.warn('New token validation failed, but caching anyway');
      }
      cacheToken(token);
    }
    return token;
  });
  return function getOrRefreshClientToken() {
    return _ref5.apply(this, arguments);
  };
}();
formsApiClient.interceptors.request.use(/*#__PURE__*/function () {
  var _ref6 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (config) {
    try {
      var token = yield getOrRefreshClientToken();
      if (token) {
        config.headers["Authorization"] = "".concat(token);
        return config;
      } else {
        return Promise.reject(new Error('No access token received'));
      }
    } catch (error) {
      console.error('Error getting token for forms API call:', error);
      return Promise.reject(new Error('Failed to get authentication token'));
    }
  });
  return function (_x3) {
    return _ref6.apply(this, arguments);
  };
}(), error => {
  return Promise.reject(error);
});
authClient.interceptors.request.use(/*#__PURE__*/function () {
  var _ref7 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (config) {
    if (config.url.includes('client/token') || config.url.includes('client/validate')) {
      return config;
    }
    try {
      var token = yield getOrRefreshClientToken();
      if (token) {
        config.headers["Authorization"] = "".concat(token);
        return config;
      } else {
        return Promise.reject(new Error('No access token received'));
      }
    } catch (error) {
      console.error('Error getting token for auth client:', error);
      return Promise.reject(new Error('Failed to get authentication token'));
    }
  });
  return function (_x4) {
    return _ref7.apply(this, arguments);
  };
}(), error => {
  return Promise.reject(error);
});

// Centralized error handling function
var handleApiError = (error, defaultMessage) => {
  var _error$response, _error$response2;
  var errorMessage = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.message) || (error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.errorDetails) === null || _error$response2 === void 0 ? void 0 : _error$response2.errorMessage) || error.message || defaultMessage;
  return {
    error: true,
    text: errorMessage
  };
};

// Form helper function for submitting forms to the API
var submitAdaptHealthForm = /*#__PURE__*/function () {
  var _ref9 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (_ref8) {
    var {
      url,
      method = "POST",
      data = {}
    } = _ref8;
    if (!url) {
      return {
        error: true,
        text: "Form endpoint is missing"
      };
    }
    try {
      var response = yield formsApiClient({
        url,
        method: method.toLowerCase(),
        data
      });
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to submit form (".concat(url, "). Please try again later."));
    }
  });
  return function submitAdaptHealthForm(_x5) {
    return _ref9.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./js/components/autoplay-text-wrapper.js":
/*!************************************************!*\
  !*** ./js/components/autoplay-text-wrapper.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initAutoplayTextWrapper)
/* harmony export */ });
/**
 * Autoplay Text Wrapper Component
 * Handles auto-rotation of autoplay-text items with animated border progress indicator
 */

class AutoplayTextWrapper {
  constructor(wrapper) {
    this.items = wrapper.querySelectorAll('.autoplay-text-wrapper__item');
    this.progressBorders = wrapper.querySelectorAll('.autoplay-text-wrapper__border-progress');
    this.delay = parseInt(wrapper.getAttribute('data-autoplay-delay')) || 3000;
    this.progressColor = wrapper.getAttribute('data-progress-color');
    this.progressBgColor = wrapper.getAttribute('data-progress-bg-color');
    this.currentIndex = 0;
    this.progressInterval = null;
    this.autoplayInterval = null;
    this.progressTimeout = null;
    this.isTransitioning = false;
    this.isInitialized = false;
    if (this.items.length <= 1) return;
    this.init();
  }
  init() {
    this.items.forEach((item, index) => {
      var headingElement = item.querySelector('.subheading__subheading-medium');
      if (headingElement) {
        headingElement.setAttribute('data-original-color', window.getComputedStyle(headingElement).color);
      }

      // Add click handler to make items clickable
      item.addEventListener('click', () => {
        this.handleItemClick(index);
      });
    });
    this.setActiveItem(0, true); // true indicates initial load
    this.isInitialized = true;
    this.startAutoplay();
  }
  handleItemClick(index) {
    // Prevent rapid clicks during transition
    if (this.isTransitioning) return;

    // Clear existing intervals and timeouts to reset progress
    this.clearAllTimers();

    // Set the clicked item as active and reset progress
    this.setActiveItem(index, false);

    // Restart autoplay
    this.startAutoplay();
  }
  setActiveItem(index) {
    var isInitialLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var previousIndex = this.currentIndex;
    var isTransitioningOut = previousIndex !== index && previousIndex !== -1;

    // Clear any pending timeout
    if (this.progressTimeout) {
      clearTimeout(this.progressTimeout);
      this.progressTimeout = null;
    }

    // Set transitioning flag
    if (isTransitioningOut) {
      this.isTransitioning = true;
    }

    // First, handle the transition out (collapse subheading)
    if (isTransitioningOut) {
      var previousItem = this.items[previousIndex];

      // Remove active class to trigger collapse animation
      previousItem === null || previousItem === void 0 || previousItem.classList.remove('autoplay-text-wrapper__item--active');

      // Reset heading color
      var previousHeading = previousItem === null || previousItem === void 0 ? void 0 : previousItem.querySelector('.subheading__subheading-medium');
      if (previousHeading) {
        previousHeading.style.color = previousHeading.getAttribute('data-original-color') || '';
      }
    }

    // Then handle the new active item
    this.items.forEach((item, i) => {
      var headingElement = item.querySelector('.subheading__subheading-medium');
      var isActive = i === index;
      if (isActive) {
        item.classList.add('autoplay-text-wrapper__item--active');
        if (headingElement) {
          headingElement.style.color = this.progressColor;
        }
      } else if (i !== previousIndex) {
        // Ensure other items are not active
        item.classList.remove('autoplay-text-wrapper__item--active');
        if (headingElement) {
          headingElement.style.color = headingElement.getAttribute('data-original-color') || '';
        }
      }
    });

    // Handle progress bar animation with proper sequencing
    this.progressBorders.forEach((border, i) => {
      var borderBase = border.previousElementSibling;
      if (i === index) {
        // Only reset progress bar if not initial load or if it's not already at 100%
        var currentWidth = parseFloat(border.style.width) || 0;
        if (!isInitialLoad || currentWidth < 100) {
          border.style.width = '0%';
        }
        border.style.backgroundColor = this.progressColor;
        if (borderBase) {
          borderBase.style.backgroundColor = this.progressBgColor;
        }

        // If transitioning from another item, wait for subheading to collapse (1000ms)
        // Then start progress bar animation
        if (isTransitioningOut) {
          this.progressTimeout = setTimeout(() => {
            this.isTransitioning = false;
            // Calculate remaining time: delay - 1000ms (wait time)
            var remainingDelay = Math.max(this.delay - 1000, 500);
            this.animateProgress(border, remainingDelay);
          }, 1000);
        } else {
          // First load or direct click - start immediately
          if (isInitialLoad && currentWidth >= 100) {
            // Don't animate if already at 100% on initial load
            return;
          }
          this.animateProgress(border, this.delay);
        }
      } else {
        border.style.width = '0%';
        border.style.backgroundColor = this.progressBgColor;
        if (borderBase) {
          borderBase.style.backgroundColor = this.progressBgColor;
        }
      }
    });
    this.currentIndex = index;
  }
  animateProgress(border, duration) {
    if (this.progressInterval) clearInterval(this.progressInterval);
    var startWidth = parseFloat(border.style.width) || 0;
    var progressWidth = startWidth;
    var stepSize = 1;
    var totalSteps = 100;
    var stepDelay = duration / totalSteps;
    this.progressInterval = setInterval(() => {
      progressWidth += stepSize;
      if (progressWidth >= 100) {
        progressWidth = 100;
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
      border.style.width = "".concat(progressWidth, "%");
    }, stepDelay);
  }
  startAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval);
    this.autoplayInterval = setInterval(() => this.nextItem(), this.delay);
  }
  nextItem() {
    // Don't transition if already transitioning
    if (this.isTransitioning) return;
    if (this.progressInterval) clearInterval(this.progressInterval);
    this.setActiveItem((this.currentIndex + 1) % this.items.length);
  }
  clearAllTimers() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
    if (this.progressTimeout) {
      clearTimeout(this.progressTimeout);
      this.progressTimeout = null;
    }
  }
  destroy() {
    this.clearAllTimers();
    this.isTransitioning = false;
  }
}
function initAutoplayTextWrapper() {
  document.querySelectorAll('.autoplay-text-wrapper').forEach(wrapper => {
    if (!wrapper.dataset.initialized) {
      new AutoplayTextWrapper(wrapper);
      wrapper.dataset.initialized = 'true';
    }
  });
}
document.addEventListener('DOMContentLoaded', initAutoplayTextWrapper);
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    var wrapper = event.target.querySelector('.autoplay-text-wrapper');
    if (wrapper) {
      wrapper.dataset.initialized = 'false';
      initAutoplayTextWrapper();
    }
  });
}

/***/ }),

/***/ "./js/components/carousel-swiper.js":
/*!******************************************!*\
  !*** ./js/components/carousel-swiper.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/modules */ "./node_modules/swiper/modules/index.mjs");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


class CarouselSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }
  connectedCallback() {
    // Get settings from script tag
    var settingsScript = this.querySelector('script[type="application/json"]');
    var settings = settingsScript ? JSON.parse(settingsScript.textContent) : {};

    // Default settings
    var defaultSettings = {
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: false,
      grabCursor: true,
      freeMode: false,
      progressBarSelector: null,
      navigation: false,
      pagination: false,
      mobileNavType: null,
      breakpoints: {},
      autoplay: false
    };
    var config = _objectSpread(_objectSpread({}, defaultSettings), settings);
    var parent = this.closest('[data-swiper-parent]');
    // Find the swiper container
    var swiperContainer = this.querySelector('.swiper');
    if (swiperContainer) {
      // Find navigation buttons if navigation is enabled
      var navigationConfig = {};
      if (config.navigation) {
        // Try to find existing navigation buttons first
        var prevButton = parent ? parent.querySelector('.swiper-button-prev') : this.querySelector('.swiper-button-prev');
        var nextButton = parent ? parent.querySelector('.swiper-button-next') : this.querySelector('.swiper-button-next');
        if (!prevButton && !nextButton) {
          prevButton = parent ? parent.querySelector('.carousel__nav-button--prev') : this.querySelector('.carousel__nav-button--prev');
          nextButton = parent ? parent.querySelector('.carousel__nav-button--next') : this.querySelector('.carousel__nav-button--next');
        }

        // If buttons don't exist, create them
        if (!prevButton && !nextButton) {
          var navigationContainer = this.querySelector('.carousel__navigation') || document.createElement('div');
          if (!navigationContainer.classList.contains('carousel__navigation')) {
            navigationContainer.className = 'carousel__navigation tw-flex tw-items-center tw-justify-end tw-gap-3 tw-mt-8';
            this.appendChild(navigationContainer);
          }

          // Create prev button
          if (!prevButton) {
            prevButton = document.createElement('button');
            prevButton.className = 'carousel__nav-button carousel__nav-button--prev tw-w-[48px] tw-h-[48px] tw-rounded-full tw-bg-white tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all hover:tw-border-slate-400 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed';
            prevButton.setAttribute('type', 'button');
            prevButton.setAttribute('aria-label', 'Previous slide');
            prevButton.setAttribute('tabindex', '0'); // Always focusable, even when disabled
            prevButton.innerHTML = "\n              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" aria-hidden=\"true\">\n                <g clip-path=\"url(#clip0_4544_4440)\">\n                  <path d=\"M47 24C47 11.2975 36.7025 1 24 1C11.2975 1 1 11.2975 1 24C1 36.7025 11.2975 47 24 47C36.7025 47 47 36.7025 47 24ZM48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z\" fill=\"#092846\"/>\n                  <path d=\"M28 16L20 24L28 32\" stroke=\"#092846\" stroke-width=\"2\"/>\n                </g>\n                <defs>\n                  <clipPath id=\"clip0_4544_4440\">\n                    <rect width=\"48\" height=\"48\" fill=\"white\"/>\n                  </clipPath>\n                </defs>\n              </svg>\n            ";
            navigationContainer.appendChild(prevButton);
          }

          // Create next button
          if (!nextButton) {
            nextButton = document.createElement('button');
            nextButton.className = 'carousel__nav-button carousel__nav-button--next tw-w-[48px] tw-h-[48px] tw-rounded-full tw-bg-white tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all hover:tw-border-slate-400 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed';
            nextButton.setAttribute('type', 'button');
            nextButton.setAttribute('aria-label', 'Next slide');
            nextButton.setAttribute('tabindex', '0'); // Always focusable, even when disabled
            nextButton.innerHTML = "\n              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" aria-hidden=\"true\">\n                <g clip-path=\"url(#clip0_4544_4437)\">\n                  <path d=\"M47 24C47 11.2975 36.7025 1 24 1C11.2975 1 1 11.2975 1 24C1 36.7025 11.2975 47 24 47C36.7025 47 47 36.7025 47 24ZM48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z\" fill=\"#092846\"/>\n                  <path d=\"M29.4141 24L20.707 32.707L19.293 31.293L26.5859 24L19.293 16.707L20.707 15.293L29.4141 24Z\" fill=\"#092846\"/>\n                </g>\n                <defs>\n                  <clipPath id=\"clip0_4544_4437\">\n                    <rect width=\"48\" height=\"48\" fill=\"white\"/>\n                  </clipPath>\n                </defs>\n              </svg>\n            ";
            navigationContainer.appendChild(nextButton);
          }
        }
        if (prevButton && nextButton) {
          navigationConfig.navigation = {
            prevEl: prevButton,
            nextEl: nextButton
          };
        }

        // Ensure buttons remain focusable when disabled - temporary fix for Shopify theme editor
        if (prevButton && nextButton) {
          // Override Swiper's default behavior of removing tabindex on disabled buttons
          var observer = new MutationObserver(() => {
            if (prevButton.hasAttribute('disabled')) {
              prevButton.setAttribute('tabindex', '0');
              prevButton.setAttribute('aria-disabled', 'true');
            } else {
              prevButton.removeAttribute('aria-disabled');
            }
            if (nextButton.hasAttribute('disabled')) {
              nextButton.setAttribute('tabindex', '0');
              nextButton.setAttribute('aria-disabled', 'true');
            } else {
              nextButton.removeAttribute('aria-disabled');
            }
          });
          observer.observe(prevButton, {
            attributes: true,
            attributeFilter: ['disabled', 'class']
          });
          observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['disabled', 'class']
          });

          // Store observer for cleanup
          this._buttonObserver = observer;
        }
      }

      // Handle pagination config
      var paginationConfig = {};
      if (config.pagination) {
        var _parent = this.closest('[data-swiper-parent]');
        var paginationEl = this.querySelector('.swiper-pagination') || (_parent ? _parent.querySelector('.swiper-pagination') : null);
        if (paginationEl) {
          paginationConfig.pagination = {
            el: paginationEl,
            type: 'bullets',
            clickable: true
          };
        }
      }

      // Handle autoplay config
      var autoplayConfig = {};
      var isAutoplayEnabled = config.autoplay && (typeof config.autoplay === 'object' || config.autoplay === true);
      if (isAutoplayEnabled) {
        var autoplaySettings = typeof config.autoplay === 'object' ? config.autoplay : {};
        autoplayConfig.autoplay = _objectSpread({
          delay: autoplaySettings.delay || 3000,
          disableOnInteraction: autoplaySettings.disableOnInteraction !== false,
          pauseOnMouseEnter: autoplaySettings.pauseOnMouseEnter || false
        }, autoplaySettings);

        // Store reference to progress bar element (legacy support)
        this.autoplayProgressBar = this.querySelector('.autoplay-progress__bar');
        // Store reference to pagination element for progress fill
        var _parent2 = this.closest('[data-swiper-parent]');
        this.paginationEl = this.querySelector('.swiper-pagination') || (_parent2 ? _parent2.querySelector('.swiper-pagination') : null);
      }

      // Determine which modules to use - always include Autoplay module
      var modules = [swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Navigation, swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Pagination, swiper_modules__WEBPACK_IMPORTED_MODULE_2__.A11y, swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Keyboard, swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Autoplay];

      // Initialize Swiper
      this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](swiperContainer, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        modules: modules,
        slidesPerView: config.slidesPerView,
        spaceBetween: config.spaceBetween,
        centeredSlides: config.centeredSlides,
        grabCursor: config.grabCursor,
        freeMode: config.freeMode,
        breakpoints: config.breakpoints,
        slidesOffsetAfter: config.slidesOffsetAfter || 0,
        // Keyboard navigation
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide'
        },
        direction: config.direction || 'horizontal'
      }, navigationConfig), paginationConfig), autoplayConfig), {}, {
        on: {
          slideChange: () => {
            this.updateProgress();
            this.updateButtonAccessibility();
            this.updateSlideFocusability();
            // Reset autoplay progress bar on slide change
            if (this.autoplayProgressBar) {
              this.autoplayProgressBar.style.width = '0%';
            }
            // Reset pagination bullet progress fill
            this.resetPaginationProgress();
          },
          init: () => {
            this.updateProgress();
            this.updateButtonAccessibility();
            this.updateSlideFocusability();
            // Reset pagination bullet progress on init
            this.resetPaginationProgress();
          },
          slideChangeTransitionEnd: () => {
            this.updateSlideFocusability();
          },
          autoplayTimeLeft: (swiper, timeLeft, progress) => {
            this.updateAutoplayProgress(progress);
          }
        }
      }));

      // Update slide focusability on window resize
      var resizeTimeout;
      var handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.updateSlideFocusability();
        }, 100);
      };
      window.addEventListener('resize', handleResize);
      this._resizeHandler = handleResize;
    }
  }
  updateProgress() {
    var settingsScript = this.querySelector('script[type="application/json"]');
    var settings = settingsScript ? JSON.parse(settingsScript.textContent) : {};
    if (settings.progressBarSelector && this.swiper) {
      var progressBar = document.querySelector(settings.progressBarSelector);
      if (progressBar) {
        var progress = (this.swiper.activeIndex + 1) / this.swiper.slides.length * 100;
        progressBar.style.width = progress + '%';
      }
    }
  }
  updateButtonAccessibility() {
    if (!this.swiper) return;
    var parent = this.closest('[data-swiper-parent]') || this;
    var prevButton = parent.querySelector('.carousel__nav-button--prev, .swiper-button-prev');
    var nextButton = parent.querySelector('.carousel__nav-button--next, .swiper-button-next');
    if (prevButton) {
      // Ensure prev button is always focusable
      prevButton.setAttribute('tabindex', '0');
      if (this.swiper.isBeginning) {
        prevButton.setAttribute('aria-disabled', 'true');
      } else {
        prevButton.removeAttribute('aria-disabled');
      }
    }
    if (nextButton) {
      // Ensure next button is always focusable
      nextButton.setAttribute('tabindex', '0');
      if (this.swiper.isEnd) {
        nextButton.setAttribute('aria-disabled', 'true');
      } else {
        nextButton.removeAttribute('aria-disabled');
      }
    }
  }
  updateSlideFocusability() {
    if (!this.swiper) return;
    var swiperContainer = this.swiper.el;
    var slides = swiperContainer.querySelectorAll('.swiper-slide');
    var swiperRect = swiperContainer.getBoundingClientRect();
    slides.forEach((slide, index) => {
      var slideRect = slide.getBoundingClientRect();
      var isVisible = slideRect.right > swiperRect.left && slideRect.left < swiperRect.right && slideRect.bottom > swiperRect.top && slideRect.top < swiperRect.bottom;

      // Find all focusable elements within the slide
      var focusableElements = slide.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach(element => {
        if (isVisible) {
          // Make visible slides focusable
          if (element.hasAttribute('tabindex') && element.getAttribute('tabindex') === '-1') {
            // Only remove tabindex if it was set to -1 by us
            element.removeAttribute('tabindex');
          }
          // For links and buttons, ensure they're naturally focusable
          if (element.tagName === 'A' || element.tagName === 'BUTTON') {
            element.removeAttribute('tabindex');
          }
        } else {
          // Make off-screen slides non-focusable
          element.setAttribute('tabindex', '-1');
        }
      });
    });
  }
  updateAutoplayProgress(progress) {
    // progress is a value between 0 and 1, where 0 means time is up and 1 means full time remaining
    // We need to convert it to show how much time has passed (1 - progress)
    if (this.autoplayProgressBar) {
      var progressPercent = (1 - progress) * 100;
      this.autoplayProgressBar.style.width = "".concat(progressPercent, "%");
    }

    // Update pagination bullet progress fill
    if (this.paginationEl) {
      var activeBullet = this.paginationEl.querySelector('.swiper-pagination-bullet-active');
      if (activeBullet) {
        var _progressPercent = (1 - progress) * 100;
        activeBullet.style.setProperty('--progress-width', "".concat(_progressPercent, "%"));
      }
    }
  }
  resetPaginationProgress() {
    if (!this.paginationEl) return;
    this.paginationEl.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => {
      bullet.style.setProperty('--progress-width', '0%');
    });
  }
  disconnectedCallback() {
    if (this._buttonObserver) {
      this._buttonObserver.disconnect();
      this._buttonObserver = null;
    }
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
      this._resizeHandler = null;
    }
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CarouselSwiper);

/***/ }),

/***/ "./js/components/financial-table.js":
/*!******************************************!*\
  !*** ./js/components/financial-table.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var financialTable = () => {
  var showYear = (wrapper, year) => {
    wrapper.querySelectorAll('.year-data-block').forEach(block => {
      block.classList.toggle('active', block.getAttribute('data-year') === year);
    });
  };
  var init = () => {
    document.querySelectorAll('[class*="financial-table-wrapper-"]').forEach(wrapper => {
      var select = wrapper.querySelector('[data-year-selector]');
      if (select) showYear(wrapper, select.value);
    });
  };
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-year-selector]')) return;
    var wrapper = e.target.closest('[class*="financial-table-wrapper-"]');
    if (wrapper) showYear(wrapper, e.target.value);
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('migrationComplete', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (financialTable);

/***/ }),

/***/ "./js/components/form-validation.js":
/*!******************************************!*\
  !*** ./js/components/form-validation.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initSimpleForm),
/* harmony export */   initFormInputListeners: () => (/* binding */ initFormInputListeners),
/* harmony export */   toggleSubmitButtonLoading: () => (/* binding */ toggleSubmitButtonLoading),
/* harmony export */   validateFormById: () => (/* binding */ validateFormById)
/* harmony export */ });
/* unused harmony exports handleFormSuccess, handleFormError, validateField, normalizeFormData, isInputVisible, updateLinkedFormElementVisibility */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! libphonenumber-js/max */ "./node_modules/libphonenumber-js/max/exports/parsePhoneNumberWithError.js");
/* harmony import */ var _api_integration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api-integration */ "./js/components/api-integration.js");



var validateEmail = email => {
  return /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/.test(email);
};
var validatePhone = phone => {
  try {
    if (!phone || phone.trim() === '') {
      return false;
    }

    // Parse phone number with max dataset (full metadata)
    var phoneNumber = (0,libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_1__.parsePhoneNumberWithError)(phone);

    // Check if the number is valid
    if (!phoneNumber || !phoneNumber.isValid()) {
      return false;
    }

    // Return the E.164 formatted number
    return phoneNumber.format('E.164');
  } catch (error) {
    // If parsing fails, the number is invalid
    return false;
  }
};
var validateDate = date => {
  if (!date || date.trim() === '') {
    return false;
  }
  // Validate YYYY-MM-DD format (HTML5 date input format)
  var dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(date)) {
    return false;
  }

  // Parse the date and verify it's valid
  var dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return false;
  }

  // Verify the date components match the input (prevents auto-corrected invalid dates like 2024-02-30 -> 2024-03-01)
  var [year, month, day] = date.split('-').map(Number);
  if (dateObj.getFullYear() !== year || dateObj.getMonth() + 1 !== month || dateObj.getDate() !== day) {
    return false;
  }

  // Return the normalized date in yyyy-mm-dd format
  var normalizedYear = dateObj.getFullYear();
  var normalizedMonth = String(dateObj.getMonth() + 1).padStart(2, '0');
  var normalizedDay = String(dateObj.getDate()).padStart(2, '0');
  return "".concat(normalizedYear, "-").concat(normalizedMonth, "-").concat(normalizedDay);
};
var getErrorMessage = fieldType => {
  return window.shopifyVariables.locales[fieldType];
};
var handleFormSuccess = function handleFormSuccess(formOrContainer) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "UI";
  var redirectUrl = arguments.length > 2 ? arguments[2] : undefined;
  if (mode === "redirect" && redirectUrl) {
    window.location.href = redirectUrl;
    return;
  }
  var successContainers = formOrContainer.querySelector('[data-form-success]');
  var formContent = formOrContainer.querySelector('[data-form-content]');
  formContent.classList.add('tw-hidden');
  successContainers.classList.remove('tw-hidden');
  // Scroll to success message
  successContainers.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
};
var handleFormError = (formOrContainer, errorMessage) => {
  // Support both regular forms and stepped forms (container)
  var errorContainers = formOrContainer.querySelectorAll('[data-form-error]');
  errorContainers.forEach(errorContainer => {
    errorContainer.textContent = errorMessage;
    errorContainer.classList.toggle('tw-hidden', !errorMessage);
    errorContainer.classList.toggle('tw-block', !!errorMessage);
  });
  console.log('Form error:', errorMessage);
};
var updateFieldErrorState = function updateFieldErrorState(field) {
  var {
    valid,
    message = ''
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var container = field.closest('[data-form-input]');
  if (!container) return;
  var errorEl = container.querySelector('[data-error-message]');
  if (!errorEl) return;
  var errorMessage = errorEl.dataset.errorMessage;
  if (!errorMessage || errorMessage.trim() == '') {
    errorMessage = message;
  }
  errorEl.textContent = valid ? '' : errorMessage;
  errorEl.classList.toggle('tw-hidden', valid);
  errorEl.classList.toggle('tw-block', !valid);
  field.toggleAttribute('aria-invalid', !valid);
};
var FIELD_VALIDATORS = {
  email: field => ({
    valid: validateEmail(field.value),
    message: getErrorMessage('email')
  }),
  tel: field => {
    var formatted = validatePhone(field.value);
    return {
      valid: formatted !== false,
      message: getErrorMessage('phone')
    };
  },
  date: field => {
    var formatted = validateDate(field.value);
    return {
      valid: formatted ? true : false,
      message: getErrorMessage('date')
    };
  },
  radio: field => {
    var group = field.closest('[data-radio-group]');
    var name = group === null || group === void 0 ? void 0 : group.getAttribute('data-radio-group');
    var checked = name ? group.querySelector("input[name=\"".concat(name, "\"]:checked")) : null;
    return {
      valid: checked ? true : false,
      message: getErrorMessage('required')
    };
  },
  checkbox: field => {
    // Check if this checkbox is part of a checkbox group
    var group = field.closest('[data-checkbox-group]');
    if (group) {
      var name = group.getAttribute('data-checkbox-group');
      var checked = name ? group.querySelector("input[name=\"".concat(name, "\"]:checked")) : null;
      return {
        valid: checked ? true : false,
        message: getErrorMessage('required')
      };
    }

    // For single checkboxes, check if this specific checkbox is checked
    return {
      valid: field.checked ? true : false,
      message: getErrorMessage('required')
    };
  },
  required: field => {
    var _field$value;
    return {
      valid: ((_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.trim()) !== '' ? true : false,
      message: getErrorMessage('required')
    };
  }
};
var validateField = function validateField(field) {
  var _field$value2;
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // Skip validation for inputs inside hidden linked form elements
  if (!isInputVisible(field)) {
    updateFieldErrorState(field, {
      valid: true
    });
    return true;
  }
  var type = field.getAttribute('data-input-type') || field.getAttribute('data-textarea-type') || field.getAttribute('data-select-type') || field.type;
  var result = {
    valid: true
  };
  if (FIELD_VALIDATORS[type]) {
    result = FIELD_VALIDATORS[type](field);
  }
  if (result.valid && isRequired) {
    result = FIELD_VALIDATORS.required(field);
  }
  //for optional fields, if the field is empty, set the valid to true
  if (!isRequired && ((_field$value2 = field.value) === null || _field$value2 === void 0 ? void 0 : _field$value2.trim()) == '') {
    result = {
      valid: true
    };
  }
  updateFieldErrorState(field, result);
  return result.valid;
};
var normalizeFormData = formInputs => {
  var formData = {};
  formInputs.forEach(input => {
    // Skip inputs inside hidden linked form elements
    if (!isInputVisible(input)) return;
    switch (input.type) {
      case "date":
        formData[input.name] = validateDate(input.value) || "";
        break;
      case "tel":
        formData[input.name] = validatePhone(input.value) || "";
        break;
      case "checkbox":
        formData[input.name] = input.checked ? "yes" : "no";
        break;
      case "radio":
        {
          var group = input.closest('[data-radio-group]');
          var name = group === null || group === void 0 ? void 0 : group.getAttribute('data-radio-group');
          var checked = name ? group.querySelector("input[name=\"".concat(name, "\"]:checked")) : null;
          formData[input.name] = checked ? checked.value : "";
          break;
        }
      default:
        formData[input.name] = input.value || "";
    }
  });
  return formData;
};

/**
 * Check if an input is visible (not inside a hidden linked form element).
 * @param {HTMLInputElement} input - The input element to check
 * @returns {boolean} - True if visible, false if hidden
 */
var isInputVisible = input => {
  var linkedParent = input.closest('[data-linked-form-element-name]');
  if (!linkedParent) return true; // Not inside a linked element, always visible
  return !linkedParent.classList.contains('tw-hidden');
};

/**
 * Toggle visibility of linked form elements based on input name and value.
 * Finds the container from the input and updates linked elements visibility.
 * @param {HTMLInputElement} input - The input element that triggered the change
 */
var updateLinkedFormElementVisibility = input => {
  var container = input.closest('[data-form-id]');
  if (!container) return;
  var inputValue = input.type === 'checkbox' ? input.checked ? 'true' : 'false' : input.value;
  if (input.type == "radio") {
    var group = input.closest('[data-radio-group]');
    var name = group === null || group === void 0 ? void 0 : group.getAttribute('data-radio-group');
    var checked = name ? group.querySelector("input[name=\"".concat(name, "\"]:checked")) : null;
    if (checked) {
      inputValue = checked.value;
    } else {
      inputValue = false;
    }
  }

  // Handle checkbox groups - check all checked checkboxes in the group
  if (input.type == "checkbox") {
    var _group = input.closest('[data-checkbox-group]');
    if (_group) {
      var _name = _group.getAttribute('data-checkbox-group');
      var allChecked = _name ? _group.querySelectorAll("input[name=\"".concat(_name, "\"]:checked")) : [];

      // Process linked elements for all checked checkboxes in the group
      allChecked.forEach(checkbox => {
        var checkboxValue = checkbox.value;
        var linkedElements = container.querySelectorAll("[data-linked-form-element-name=\"".concat(_name, "\"]"));
        linkedElements.forEach(linkedElement => {
          var expectedValue = linkedElement.dataset.linkedFormElementValue;
          var isMatch = expectedValue.toLowerCase() === checkboxValue.toLowerCase();
          linkedElement.classList.toggle('tw-hidden', !isMatch);
          linkedElement.classList.toggle('tw-block', isMatch);
          var parent = linkedElement.closest('.form-row-item');
          parent.classList.toggle('tw-hidden', !isMatch);
          parent.classList.toggle('!tw-block', isMatch);
          if (!isMatch) {
            linkedElement.value = '';
          }
        });
      });

      // Also hide linked elements for unchecked checkboxes
      var allUnchecked = _name ? _group.querySelectorAll("input[name=\"".concat(_name, "\"]:not(:checked)")) : [];
      allUnchecked.forEach(checkbox => {
        var checkboxValue = checkbox.value;
        var linkedElements = container.querySelectorAll("[data-linked-form-element-name=\"".concat(_name, "\"]"));
        linkedElements.forEach(linkedElement => {
          var expectedValue = linkedElement.dataset.linkedFormElementValue;
          if (expectedValue.toLowerCase() === checkboxValue.toLowerCase()) {
            linkedElement.classList.add('tw-hidden');
            linkedElement.classList.remove('tw-block');
            var parent = linkedElement.closest('.form-row-item');
            parent.classList.add('tw-hidden');
            parent.classList.remove('!tw-block');
            linkedElement.value = '';
          }
        });
      });
      return; // Early return since we've handled checkbox groups
    }
  }
  if (!inputValue) return;
  var linkedElements = container.querySelectorAll("[data-linked-form-element-name=\"".concat(input.name, "\"]"));
  linkedElements.forEach(linkedElement => {
    var expectedValue = linkedElement.dataset.linkedFormElementValue;
    var isMatch = expectedValue.toLowerCase() === inputValue.toLowerCase();
    linkedElement.classList.toggle('tw-hidden', !isMatch);
    linkedElement.classList.toggle('tw-block', isMatch);
    var parent = linkedElement.closest('.form-row-item');
    parent.classList.toggle('tw-hidden', !isMatch);
    parent.classList.toggle('!tw-block', isMatch);
    if (!isMatch) {
      linkedElement.value = '';
    }
  });
};

/**
 * Initialize input listeners for validation and linked form element visibility.
 * Reusable for both simple forms and stepped forms.
 * @param {NodeList|Array} inputs - The input elements to attach listeners to
 */
var initFormInputListeners = inputs => {
  inputs.forEach(input => {
    var isRequired = input.dataset.required === 'true';
    var inputType = input.getAttribute('data-input-type') || input.type;

    // Prevent spaces in phone input fields
    if (inputType === 'tel') {
      // Prevent spacebar using multiple event types for better coverage
      var preventSpace = e => {
        if (e.key === ' ' || e.code === 'Space' || e.keyCode === 32) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      };

      // Use beforeinput for modern browsers (most reliable - fires before input is inserted)
      input.addEventListener('beforeinput', e => {
        if (e.data && e.data.includes(' ')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }, {
        capture: true
      });

      // Fallback for older browsers
      input.addEventListener('keydown', preventSpace, {
        capture: true
      });
      input.addEventListener('keypress', preventSpace, {
        capture: true
      });

      // Remove any spaces that might have been pasted or entered via other methods
      // Also handle cases where spaces might be converted to dots by browser/OS
      input.addEventListener('input', e => {
        var originalValue = input.value;
        // Remove all spaces
        var cleanedValue = originalValue.replace(/\s+/g, '');

        // If a dot appears where a space was (common OS behavior), remove it
        // Check if dot was inserted in a position that suggests it replaced a space
        // We'll be conservative and only remove dots that are clearly problematic
        // For now, just focus on spaces - if dots are still an issue, we can add more logic

        if (originalValue !== cleanedValue) {
          // Save cursor position
          var cursorPosition = input.selectionStart;
          var beforeCursor = originalValue.substring(0, cursorPosition);
          var spacesBeforeCursor = (beforeCursor.match(/\s/g) || []).length;
          input.value = cleanedValue;

          // Restore cursor position (adjust for removed spaces)
          var newPosition = Math.max(0, cursorPosition - spacesBeforeCursor);
          input.setSelectionRange(newPosition, newPosition);

          // Stop propagation to prevent other handlers from processing the space
          e.stopPropagation();
        }
      }, {
        capture: true
      }); // Use capture phase to run before validation
    }
    var handleInputChange = () => {
      validateField(input, isRequired);
      updateLinkedFormElementVisibility(input);
    };
    input.addEventListener('input', handleInputChange);
    input.addEventListener('change', handleInputChange);

    // Initialize linked visibility on load
    updateLinkedFormElementVisibility(input);
  });
};
var toggleSubmitButtonLoading = function toggleSubmitButtonLoading(submitButton) {
  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!submitButton) return;
  var button = submitButton.querySelector('button, a');
  if (!button) return;
  var buttonLabel = submitButton.querySelector('[data-button-label]');
  var buttonSpinner = submitButton.querySelector('[data-button-spinner]');
  if (!buttonLabel || !buttonSpinner) return;
  if (isLoading) {
    // Disable the button and show spinner
    button.disabled = true;
    button.setAttribute('data-button-disabled', 'true');
    buttonLabel.classList.add('tw-hidden');
    buttonSpinner.classList.remove('tw-hidden');
    buttonSpinner.classList.add('tw-flex');
  } else {
    // Enable the button and hide spinner
    button.disabled = false;
    button.setAttribute('data-button-disabled', 'false');
    buttonLabel.classList.remove('tw-hidden');
    buttonSpinner.classList.add('tw-hidden');
    buttonSpinner.classList.remove('tw-flex');
  }
};
function validateFormById(formId) {
  var forms = document.querySelectorAll("[data-form-id=\"".concat(formId, "\"]"));
  var normalizedData = null;
  if (!forms.length) return;
  forms.forEach(form => {
    var inputs = form.querySelectorAll('input, textarea, select');
    var hasErrors = false;
    var firstErrorElement = null;
    inputs.forEach(input => {
      // Skip inputs inside hidden linked form elements
      if (!isInputVisible(input)) return;
      var isRequired = input.dataset.required === 'true';
      var valid = validateField(input, isRequired);
      if (!valid && !hasErrors) {
        hasErrors = true;
        firstErrorElement = input.closest('[data-form-input]');
      }
    });
    if (hasErrors && firstErrorElement) {
      var _firstErrorElement$qu;
      firstErrorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      (_firstErrorElement$qu = firstErrorElement.querySelector('input, textarea, select')) === null || _firstErrorElement$qu === void 0 || _firstErrorElement$qu.focus({
        preventScroll: true
      });
      return null;
    }
    normalizedData = normalizeFormData(inputs);
  });
  return normalizedData;
}
function initSimpleForm() {
  var formId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var forms = formId ? document.querySelectorAll("[data-form-id=\"".concat(formId, "\"]")) : document.querySelectorAll('[data-form-id]');
  forms.forEach(form => {
    if (form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';
    var inputs = form.querySelectorAll('input, textarea, select');
    var submitButton = form.querySelector('[data-form-submit]');
    if (!submitButton) return;

    // Initialize input listeners for validation + linked visibility
    initFormInputListeners(inputs);
    submitButton.addEventListener('click', /*#__PURE__*/function () {
      var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (e) {
        e.preventDefault();
        var data = validateFormById(form.dataset.formId);
        if (!data) return;
        toggleSubmitButtonLoading(submitButton, true);
        try {
          var response = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_2__.submitAdaptHealthForm)({
            url: form.dataset.formUrl,
            method: form.dataset.formMethod,
            data
          });
          if (response !== null && response !== void 0 && response.error) {
            toggleSubmitButtonLoading(submitButton, false);
            handleFormError(form, response.text);
            return;
          }
          handleFormSuccess(form, form.dataset.formMode, form.dataset.formRedirectUrl);
        } catch (err) {
          toggleSubmitButtonLoading(submitButton, false);
          handleFormError(form, 'Failed to submit form');
        }
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
}

/***/ }),

/***/ "./js/components/header.js":
/*!*********************************!*\
  !*** ./js/components/header.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var JsComponents_api_integration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/api-integration.js */ "./js/components/api-integration.js");


/**
 * Move megamenu section content into header placeholders and
 * attach hover/focus interactions for desktop navigation.
 *
 * - Megamenu sections: `.megamenu-section[data-megamenu-id]`
 * - Desktop placeholders: `.site-header__megamenu-placeholder[data-megamenu-id]`
 * - Mobile placeholders: `.site-header__mobile-megamenu-placeholder[data-megamenu-id]`
 */
function initHeaderMegamenu() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var header = root.querySelector('[data-header]') || document.querySelector('[data-header]');
  if (!header) return;
  if (header.dataset.megamenuInitialized === 'true') return;
  header.dataset.megamenuInitialized = 'true';

  // ================================
  // Move megamenu section content
  // ================================
  var sections = root.querySelectorAll('[data-megamenu-section]');
  sections.forEach(section => {
    var id = section.dataset.megamenuId;
    if (!id || section.dataset.megamenuMounted === 'true') return;
    var fragment = document.createDocumentFragment();
    while (section.firstChild) {
      fragment.appendChild(section.firstChild);
    }
    if (section.dataset.megamenuDesktopContent == "true") {
      var desktopTarget = root.querySelector("[data-megamenu-desktop][data-megamenu-id=\"".concat(id, "\"]"));
      if (desktopTarget) {
        desktopTarget.innerHTML = '';
        desktopTarget.appendChild(fragment.cloneNode(true));
      }
    }
    if (section.dataset.megamenuMobileContent == "true") {
      var mobileTarget = root.querySelector("[data-megamenu-mobile][data-megamenu-id=\"".concat(id, "\"]"));
      if (mobileTarget) {
        mobileTarget.innerHTML = '';
        mobileTarget.appendChild(fragment.cloneNode(true));
      }
    }
    section.style.display = 'none';
    section.dataset.megamenuMounted = 'true';
  });

  // ================================
  // Desktop hover / focus interactivity
  // ================================
  var triggers = header.querySelectorAll('[data-megamenu-trigger]');
  var panels = header.querySelectorAll('[data-megamenu-desktop][data-megamenu-id]');
  var activePanel = null;
  var hideAllPanels = () => {
    panels.forEach(panel => panel.classList.add('tw-hidden'));
    activePanel = null;
  };
  var showPanel = panel => {
    if (activePanel === panel) return;
    hideAllPanels(); // <-- INSTANT CLOSE (fix)
    panel.classList.remove('tw-hidden');
    activePanel = panel;
  };
  var insidePanel = false;
  var insideTrigger = false;
  triggers.forEach(trigger => {
    var id = trigger.dataset.megamenuTrigger;
    if (!id) return;
    var panel = header.querySelector("[data-megamenu-desktop][data-megamenu-id=\"".concat(id, "\"]"));
    if (!panel) return;

    // Find the actual clickable element (usually an <a> tag inside the trigger)
    var linkElement = trigger.querySelector('a') || trigger;

    // -----------------------------------
    // Prevent default navigation for megamenu triggers
    // -----------------------------------
    // Prevent click navigation (megamenu triggers should open menu, not navigate)
    if (linkElement.tagName === 'A') {
      linkElement.addEventListener('click', e => {
        // Always prevent navigation for megamenu triggers
        e.preventDefault();
        e.stopPropagation();
        // Toggle panel on click
        if (activePanel === panel) {
          hideAllPanels();
          trigger.classList.remove('is-active');
        } else {
          insideTrigger = true;
          showPanel(panel);
          trigger.classList.add('is-active');
        }
      });
    }

    // -----------------------------------
    // Hover Trigger → Open panel
    // -----------------------------------
    trigger.addEventListener('mouseenter', () => {
      insideTrigger = true;
      showPanel(panel);
      trigger.classList.add('is-active');
    });
    trigger.addEventListener('mouseleave', () => {
      insideTrigger = false;
      trigger.classList.remove('is-active');
      setTimeout(() => {
        if (!insideTrigger && !insidePanel) hideAllPanels();
      }, 80);
    });

    // -----------------------------------
    // Keyboard navigation (Enter/Space to toggle, not on focus)
    // ROOT FIX: Single centralized keyboard handler for accessibility
    // -----------------------------------

    // Centralized keyboard handler - single source of truth
    var handleKeyboardAccessibility = e => {
      var _target$getAttribute;
      var isMenuOpen = activePanel === panel && !panel.classList.contains('tw-hidden');
      var isTriggerFocused = document.activeElement === linkElement;
      var isInsidePanel = panel.contains(document.activeElement);
      var target = e.target;
      var isMegamenuLink = target.tagName === 'A' && ((_target$getAttribute = target.getAttribute('href')) === null || _target$getAttribute === void 0 ? void 0 : _target$getAttribute.includes('#megamenu-'));

      // Escape: Always close menu
      if (e.key === 'Escape' && isMenuOpen) {
        e.preventDefault();
        e.stopPropagation();

        // Check if this is a condensed megamenu and focus is inside active panel
        var isCondensedMegamenu = panel.querySelector('[data-megamenu-panel]') !== null;
        if (isCondensedMegamenu && isInsidePanel) {
          // For condensed megamenu: return focus to trigger
          hideAllPanels();
          trigger.classList.remove('is-active');
          insidePanel = false;
          linkElement.focus();
          return;
        }

        // Default behavior for non-condensed or when focus is on trigger
        hideAllPanels();
        trigger.classList.remove('is-active');
        insidePanel = false;
        linkElement.focus();
        return;
      }

      // Enter/Space: Toggle menu
      if (e.key === 'Enter' || e.key === ' ') {
        // Case 1: Focus is on trigger link
        if (isTriggerFocused) {
          e.preventDefault();
          e.stopPropagation();
          if (isMenuOpen) {
            // Second Enter: Close menu
            hideAllPanels();
            trigger.classList.remove('is-active');
            insideTrigger = false;
            insidePanel = false;
            linkElement.focus();
          } else {
            // First Enter: Open menu (keep focus on trigger)
            insideTrigger = true;
            showPanel(panel);
            trigger.classList.add('is-active');
            // Focus stays on trigger - user must press Tab to move to first item
          }
          return;
        }

        // Case 2: Focus is inside panel and menu is open
        if (isInsidePanel && isMenuOpen) {
          // If it's a megamenu link, close current menu (second Enter behavior)
          if (isMegamenuLink) {
            e.preventDefault();
            e.stopPropagation();
            hideAllPanels();
            trigger.classList.remove('is-active');
            insidePanel = false;
            linkElement.focus();
            return;
          }
          // For regular links, let them navigate normally
          return;
        }
      }

      // Tab: Handle navigation from trigger to first menu item, or from last item to next nav link
      // Re-check menu state to ensure it's current (in case it changed)
      var currentMenuOpen = activePanel === panel && !panel.classList.contains('tw-hidden');
      if (e.key === 'Tab' && !e.shiftKey && currentMenuOpen) {
        // Case 1: Focus is on trigger - move to first menu item
        // Re-check trigger focus state to ensure it's current
        var currentTriggerFocused = document.activeElement === linkElement;
        if (currentTriggerFocused) {
          // Ensure panel is actually visible before trying to focus inside it
          if (panel.classList.contains('tw-hidden')) {
            // Panel is hidden, allow normal Tab behavior
            return;
          }
          e.preventDefault();
          e.stopPropagation();

          // Check if this is a condensed megamenu
          var _isCondensedMegamenu = panel.querySelector('[data-megamenu-panel]') !== null;
          if (_isCondensedMegamenu) {
            // For condensed megamenu: move to first first-level button (tab button)
            var firstLevelButtons = panel.querySelectorAll('[data-megamenu-tab]');
            var visibleFirstLevelButton = Array.from(firstLevelButtons).find(button => {
              var style = window.getComputedStyle(button);
              var rect = button.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !button.closest('[hidden]');
            });
            if (visibleFirstLevelButton) {
              // Close ALL active panels and buttons to prevent edge cases
              var allActiveButtons = panel.querySelectorAll('[data-megamenu-tab].is-active');
              allActiveButtons.forEach(button => {
                button.classList.remove('is-active');
                var tabId = button.getAttribute('data-megamenu-tab');
                var correspondingPanel = panel.querySelector("[data-megamenu-panel=\"".concat(tabId, "\"]"));
                if (correspondingPanel) {
                  correspondingPanel.classList.remove('is-active');
                }
              });

              // Also close any active panels that might not have corresponding buttons
              var allActivePanels = panel.querySelectorAll('[data-megamenu-panel].is-active');
              allActivePanels.forEach(activePanel => {
                activePanel.classList.remove('is-active');
              });
              visibleFirstLevelButton.focus();
              insidePanel = true;
              return;
            }
          } else {
            // For non-condensed megamenu: move to first focusable element in panel
            // First, try to find direct links/buttons (first-level items)
            var focusableElements = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            var visibleFocusable = Array.from(focusableElements).filter(el => {
              // Exclude trigger and linkElement
              if (el === linkElement || trigger.contains(el)) return false;
              // Exclude nested menu toggles that are inside nested menus (they'll be handled by their own handlers)
              // But include first-level menu toggles that are direct children of the panel
              var style = window.getComputedStyle(el);
              var rect = el.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
            });
            if (visibleFocusable.length > 0) {
              // Focus the first visible focusable element
              // Use requestAnimationFrame to ensure DOM is ready and panel is fully visible
              requestAnimationFrame(() => {
                visibleFocusable[0].focus();
              });
              insidePanel = true;
              return;
            }

            // If no focusable elements found, allow normal Tab behavior
            // This shouldn't happen, but provides fallback
          }
          return;
        }

        // Case 2: Focus is inside panel - handle navigation
        if (isInsidePanel) {
          var _isCondensedMegamenu2 = panel.querySelector('[data-megamenu-panel]') !== null;
          var currentFocus = document.activeElement;

          // Check if focus is on a first-level button (tab button)
          var isFirstLevelButton = currentFocus.hasAttribute('data-megamenu-tab');
          if (_isCondensedMegamenu2 && isFirstLevelButton) {
            var _activePanel = panel.querySelector('[data-megamenu-panel].is-active');

            // Only intercept Tab if there's an active panel
            if (_activePanel) {
              // Tab from first-level button: move to first focusable element in active panel
              e.preventDefault();
              e.stopPropagation();
              var _focusableElements = _activePanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
              var _visibleFocusable = Array.from(_focusableElements).filter(el => {
                if (el === linkElement || trigger.contains(el)) return false;
                var style = window.getComputedStyle(el);
                var rect = el.getBoundingClientRect();
                return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
              });
              if (_visibleFocusable.length > 0) {
                _visibleFocusable[0].focus();
                return;
              }
            }
            // If no active panel, Tab should move to next first-level button
            // Handle this explicitly to ensure proper navigation
            e.preventDefault();
            e.stopPropagation();
            var _firstLevelButtons = panel.querySelectorAll('[data-megamenu-tab]');
            var visibleButtons = Array.from(_firstLevelButtons).filter(button => {
              var style = window.getComputedStyle(button);
              var rect = button.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !button.closest('[hidden]');
            });
            var currentButtonIndex = visibleButtons.indexOf(currentFocus);
            if (currentButtonIndex >= 0 && currentButtonIndex < visibleButtons.length - 1) {
              // Move to next first-level button
              visibleButtons[currentButtonIndex + 1].focus();
              return;
            }
            // If on last first-level button, fall through to exit logic
          }

          // Handle Tab on last item - different logic for condensed vs non-condensed
          if (_isCondensedMegamenu2) {
            // For condensed megamenu: check if we're on last item WITHIN the active panel
            var _activePanel2 = panel.querySelector('[data-megamenu-panel].is-active');
            if (_activePanel2 && _activePanel2.contains(currentFocus)) {
              // We're inside an active panel - check if we're on the last item in that panel
              var panelFocusableElements = _activePanel2.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
              var visiblePanelFocusable = Array.from(panelFocusableElements).filter(el => {
                if (el === linkElement || trigger.contains(el)) return false;
                var style = window.getComputedStyle(el);
                var rect = el.getBoundingClientRect();
                return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
              });
              var currentIndex = visiblePanelFocusable.indexOf(currentFocus);
              var isLastItemInPanel = currentIndex === visiblePanelFocusable.length - 1;
              if (isLastItemInPanel) {
                // Last item in active panel - move to next first-level button
                e.preventDefault();
                e.stopPropagation();
                var _firstLevelButtons2 = panel.querySelectorAll('[data-megamenu-tab]');
                var _visibleButtons = Array.from(_firstLevelButtons2).filter(button => {
                  var style = window.getComputedStyle(button);
                  var rect = button.getBoundingClientRect();
                  return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !button.closest('[hidden]');
                });

                // Find which button corresponds to current active panel
                var activePanelId = _activePanel2.getAttribute('data-megamenu-panel');
                var _currentButtonIndex = _visibleButtons.findIndex(btn => btn.getAttribute('data-megamenu-tab') === activePanelId);

                // Move to next first-level button
                if (_currentButtonIndex >= 0 && _currentButtonIndex < _visibleButtons.length - 1) {
                  _visibleButtons[_currentButtonIndex + 1].focus();
                  return;
                }

                // If no more buttons, exit megamenu normally (fall through to exit logic)
              } else {
                // Not last item in panel - allow normal Tab navigation
                return;
              }
            }
            // If not inside active panel (shouldn't happen, but handle gracefully)
            // Fall through to exit logic
          } else {
            // For non-condensed megamenu: check if we're on last item in entire panel
            var _focusableElements2 = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            var _visibleFocusable2 = Array.from(_focusableElements2).filter(el => {
              if (el === linkElement || trigger.contains(el)) return false;
              var style = window.getComputedStyle(el);
              var rect = el.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
            });
            var _currentIndex = _visibleFocusable2.indexOf(currentFocus);
            var isLastItem = _currentIndex === _visibleFocusable2.length - 1;
            if (!isLastItem) {
              // Not last item - allow normal Tab navigation
              return;
            }
            // If last item, fall through to exit logic
          }

          // Exit megamenu (for both condensed and non-condensed when on last item)
          e.preventDefault();
          e.stopPropagation();
          var allNavLinks = Array.from(header.querySelectorAll('.site-header__nav-link'));
          var triggersArray = Array.from(triggers);
          var currentTriggerIndex = triggersArray.indexOf(trigger);
          var _loop = function _loop() {
              var nextTrigger = triggersArray[i];
              var nextLink = nextTrigger.querySelector('.site-header__nav-link');
              if (nextLink) {
                hideAllPanels();
                trigger.classList.remove('is-active');
                insidePanel = false;
                setTimeout(() => {
                  nextLink.focus();
                }, 0);
                return {
                  v: void 0
                };
              }
            },
            _ret;
          for (var i = currentTriggerIndex + 1; i < triggersArray.length; i++) {
            _ret = _loop();
            if (_ret) return _ret.v;
          }
          var currentLinkIndex = allNavLinks.indexOf(linkElement);
          if (currentLinkIndex < allNavLinks.length - 1) {
            hideAllPanels();
            trigger.classList.remove('is-active');
            insidePanel = false;
            setTimeout(() => {
              allNavLinks[currentLinkIndex + 1].focus();
            }, 0);
          }
        }
      }

      // Shift+Tab: Handle navigation from first item back to trigger or first-level button
      if (e.key === 'Tab' && e.shiftKey && isMenuOpen) {
        var _currentFocus = document.activeElement;
        var _isCondensedMegamenu3 = panel.querySelector('[data-megamenu-panel]') !== null;

        // Check if focus is inside active panel (for condensed megamenu)
        if (_isCondensedMegamenu3) {
          var _activePanel3 = panel.querySelector('[data-megamenu-panel].is-active');
          if (_activePanel3 && _activePanel3.contains(_currentFocus)) {
            var _focusableElements3 = _activePanel3.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            var _visibleFocusable3 = Array.from(_focusableElements3).filter(el => {
              if (el === linkElement || trigger.contains(el)) return false;
              var style = window.getComputedStyle(el);
              var rect = el.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
            });
            if (_visibleFocusable3.length > 0) {
              var firstElement = _visibleFocusable3[0];
              var isFirstElementFocused = _currentFocus === firstElement;

              // If Shift+Tab on first element, move focus back to first-level button (the one that triggered)
              // and close the active panel
              if (isFirstElementFocused) {
                e.preventDefault();
                e.stopPropagation();

                // Find the first-level button that corresponds to the active panel
                var _activePanelId = _activePanel3.getAttribute('data-megamenu-panel');
                var correspondingButton = panel.querySelector("[data-megamenu-tab=\"".concat(_activePanelId, "\"]"));
                if (correspondingButton) {
                  // Close the active panel by removing is-active class
                  _activePanel3.classList.remove('is-active');
                  correspondingButton.classList.remove('is-active');
                  correspondingButton.focus();
                  insidePanel = false;
                  return;
                }
              }
            }
          }
        }

        // Check if focus is on first item in panel (fallback for non-condensed)
        if (panel.contains(_currentFocus)) {
          var _focusableElements4 = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
          var _visibleFocusable4 = Array.from(_focusableElements4).filter(el => {
            if (el === linkElement || trigger.contains(el)) return false;
            var style = window.getComputedStyle(el);
            var rect = el.getBoundingClientRect();
            return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
          });
          if (_visibleFocusable4.length > 0) {
            var _firstElement = _visibleFocusable4[0];
            var _isFirstElementFocused = _currentFocus === _firstElement;

            // If Shift+Tab on first element, move focus back to trigger
            if (_isFirstElementFocused) {
              e.preventDefault();
              e.stopPropagation();
              linkElement.focus();
              insidePanel = false;
            }
          }
        }
      }
    };

    // Attach single keyboard handler to both trigger and panel
    linkElement.addEventListener('keydown', handleKeyboardAccessibility);
    panel.addEventListener('keydown', handleKeyboardAccessibility);
    linkElement.addEventListener('focusout', e => {
      // Only close if focus is moving outside the trigger and panel
      var relatedTarget = e.relatedTarget;
      // Allow focus to move into the panel - don't close if focus is moving to panel content
      if (relatedTarget && panel.contains(relatedTarget)) {
        // Focus moved into the panel - keep it open
        insidePanel = true;
        return;
      }
      if (!panel.contains(relatedTarget) && relatedTarget !== trigger && relatedTarget !== linkElement) {
        insideTrigger = false;
        setTimeout(() => {
          if (!insideTrigger && !insidePanel) {
            hideAllPanels();
            trigger.classList.remove('is-active');
          }
        }, 80);
      }
    });

    // Handle focusout on panel to detect when focus leaves the panel
    panel.addEventListener('focusout', e => {
      var relatedTarget = e.relatedTarget;
      if (!relatedTarget) return;

      // Check if focus is moving to another navigation element in the header
      var isMovingToNavLink = relatedTarget.classList.contains('site-header__nav-link') || relatedTarget.closest('.site-header__nav-link');
      var isMovingToNavItem = relatedTarget.closest('.site-header__nav-item');
      var isMovingToMenuTrigger = relatedTarget.closest('[data-megamenu-trigger]');
      var isMovingToHeaderNav = relatedTarget.closest('.site-header__nav');

      // If focus is moving to any header navigation element (nav-link, nav-item, or another menu trigger), allow it
      if (isMovingToNavLink || isMovingToNavItem || isMovingToMenuTrigger || isMovingToHeaderNav) {
        // Focus is moving to another navigation element - close current panel
        insidePanel = false;
        hideAllPanels();
        trigger.classList.remove('is-active');
        return;
      }

      // If focus is moving outside the panel and not to any header navigation element, close the panel
      if (!panel.contains(relatedTarget) && relatedTarget !== linkElement && !trigger.contains(relatedTarget)) {
        insidePanel = false;
        setTimeout(() => {
          if (!insideTrigger && !insidePanel) {
            hideAllPanels();
            trigger.classList.remove('is-active');
          }
        }, 80);
      }
    });

    // -----------------------------------
    // Keep panel open while mouse is inside
    // -----------------------------------
    panel.addEventListener('mouseenter', () => {
      insidePanel = true;
      trigger.classList.add('is-active');
      showPanel(panel);
    });
    panel.addEventListener('mouseleave', () => {
      insidePanel = false;
      trigger.classList.remove('is-active');
      setTimeout(() => {
        if (!insideTrigger && !insidePanel) hideAllPanels();
      }, 80);
    });
  });
}

/**
 * Initialize mobile sliding panel navigation (panel-based).
 */
function initMobileNestedNav() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var drawer = root.querySelector('[data-slide-panel-root]');
  if (!drawer) return;
  var navRoot = drawer.querySelector('[data-slide-panels]');
  if (!navRoot || navRoot.dataset.mobileNavInitialized === 'true') return;
  navRoot.dataset.mobileNavInitialized = 'true';
  var panelsContainer = navRoot;
  if (!panelsContainer) return;

  /**
   * Set the active panel by id, sliding all others out of view.
   * Uses translate-x-0 for active, translate-x-full for others.
   */
  var currentActiveId = 'root';
  var currentDepth = 0;
  function setActivePanel(panelId) {
    var panels = panelsContainer.querySelectorAll('[data-slide-panel]');
    var newPanel = panelsContainer.querySelector("[data-panel-id=\"".concat(panelId, "\"]"));
    if (!newPanel) return;
    var newDepth = Number(newPanel.dataset.panelDepth || 0);
    var isForward = newDepth > currentDepth;
    var fromId = currentActiveId;
    currentActiveId = panelId;
    currentDepth = newDepth;
    panels.forEach(panel => {
      var id = panel.dataset.panelId;
      if (id === fromId) {
        // Previously active panel
        panel.classList.remove('tw-translate-x-0');
        if (isForward) {
          // Going deeper: push previous panel LEFT
          panel.classList.remove('tw-translate-x-full');
          panel.classList.add('tw-translate-x-[-100%]');
        } else {
          // Going back: push previous panel RIGHT
          panel.classList.remove('tw-translate-x-[-100%]');
          panel.classList.add('tw-translate-x-full');
        }
        panel.style.zIndex = 20;
        panel.setAttribute('aria-hidden', 'true');
        return;
      }
      if (id === panelId) {
        // New active panel
        panel.classList.remove('tw-translate-x-full', 'tw-translate-x-[-100%]');
        panel.classList.add('tw-translate-x-0');
        panel.style.zIndex = 30;
        panel.setAttribute('aria-hidden', 'false');
        return;
      }
    });
  }
  window.setActivePanel = setActivePanel;
  window.closePanel = closePanel;
  window.getCurrentActivePanel = () => {
    return currentActiveId;
  };
  function closePanel(panelId) {
    var panels = panelsContainer.querySelectorAll('[data-slide-panel]');
    var panel = panelsContainer.querySelector("[data-panel-id=\"".concat(panelId, "\"]"));
    if (!panel) return;
    panel.classList.add('tw-translate-x-full');
    panel.style.zIndex = 20;
    panel.setAttribute('aria-hidden', 'true');
  }

  // Nav forward: clicking a link or button with data-panel-target
  panelsContainer.addEventListener('click', function (e) {
    var navTrigger = e.target.closest('[data-panel-target]');
    if (navTrigger) {
      e.preventDefault();
      var targetId = navTrigger.getAttribute('data-panel-target');
      if (targetId) {
        setActivePanel(targetId);
      }
      return;
    }
    // Nav back: clicking back button
    var backBtn = e.target.closest('[data-mobile-nav-back][data-panel-parent]');
    if (backBtn) {
      e.preventDefault();
      var parentId = backBtn.getAttribute('data-panel-parent');
      if (parentId) {
        setActivePanel(parentId);
      }
      return;
    }
  });

  // Optional: swipe to navigate back (touch events)
  var touchStartX = null;
  panelsContainer.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) {
      touchStartX = e.touches[0].clientX;
    }
  });
  panelsContainer.addEventListener('touchend', function (e) {
    if (touchStartX !== null && e.changedTouches.length === 1) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      // Simple heuristic: swipe right
      if (dx > 60) {
        // Find visible panel and trigger back
        var activePanel = panelsContainer.querySelector('.slide-panel.tw-translate-x-0');
        var backBtn = activePanel && activePanel.querySelector('[data-mobile-nav-back][data-panel-parent]');
        if (backBtn) backBtn.click();
      }
    }
    touchStartX = null;
  });
}
/**
 * Initialize desktop hover menu
 */
function initHoverNestedMenu() {
  var {
    toggleAttr = 'data-menu-toggle',
    menuAttr = 'data-nested-menu',
    activeClass = 'is-active',
    parentEl = 'data-nested-menu-parent',
    forceVisible = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var toggles = document.querySelectorAll("[".concat(toggleAttr, "]"));
  toggles.forEach(toggle => {
    var parent = toggle.closest("[".concat(parentEl, "]"));
    var nestedMenu = parent === null || parent === void 0 ? void 0 : parent.querySelector("[".concat(menuAttr, "]"));
    //handle for nested menu
    if (toggle.dataset.megamenuTab) {
      var megamenuId = toggle.dataset.megamenuTab;
      nestedMenu = parent === null || parent === void 0 ? void 0 : parent.querySelector("[data-megamenu-panel=\"".concat(megamenuId, "\"]"));
    }
    if (!nestedMenu) return;

    // Find the actual focusable element (usually an <a> tag inside the toggle)
    var linkElement = toggle.querySelector('a') || toggle;
    var hoverInside = false;
    var hideAllPanels = () => {
      parent.querySelectorAll("[".concat(menuAttr, "]")).forEach(menu => {
        if (menu.classList.remove(activeClass)) {
          menu.classList.remove(activeClass);
        }
      });
    };
    var removeActiveClassFromToggle = () => {
      parent.querySelectorAll("[".concat(toggleAttr, "]")).forEach(toggle => {
        if (toggle.classList.remove(activeClass)) {
          toggle.classList.remove(activeClass);
        }
      });
    };
    var showMenu = () => {
      hideAllPanels();
      removeActiveClassFromToggle();
      nestedMenu.classList.add(activeClass);
      toggle.classList.add(activeClass);
    };
    var hideMenu = () => {
      // Note: This function does NOT handle focus - focus is only managed for keyboard accessibility
      if (!hoverInside && !forceVisible) {
        toggle.classList.remove(activeClass);
        nestedMenu.classList.remove(activeClass);
      }
    };

    // Hover on the toggle opens the menu
    toggle.addEventListener('mouseenter', () => {
      hoverInside = true;
      showMenu();
    });
    toggle.addEventListener('mouseleave', () => {
      hoverInside = false;
      setTimeout(hideMenu, 50); // Small delay prevents flicker
    });

    // Shared Escape handler - works from both toggle and nested menu (like megamenu pattern)
    var handleEscape = e => {
      if (e.key !== 'Escape') return;

      // Only handle escape if this nested menu is actually open
      var isMenuOpen = nestedMenu.classList.contains(activeClass);
      if (!isMenuOpen) return;

      // Check if we're inside a megamenu - if so, let megamenu handler take precedence
      var isInsideMegamenu = toggle.closest('[data-megamenu-desktop]') || toggle.closest('[data-megamenu-trigger]') || nestedMenu.closest('[data-megamenu-desktop]');

      // If inside megamenu and megamenu is open, don't handle here - let event bubble to megamenu handler
      if (isInsideMegamenu) {
        var megamenuPanel = nestedMenu.closest('[data-megamenu-desktop]');
        if (megamenuPanel && !megamenuPanel.classList.contains('tw-hidden')) {
          // Don't prevent default or stop propagation - let megamenu handler catch it
          return; // Let megamenu handler deal with it
        }
      }

      // Not inside megamenu (or megamenu is closed) - handle Escape here
      e.preventDefault();
      e.stopPropagation();
      hoverInside = false;
      // Directly close menu (bypass forceVisible for keyboard accessibility)
      toggle.classList.remove(activeClass);
      nestedMenu.classList.remove(activeClass);
      linkElement.focus(); // Keyboard-only: Return focus to trigger link for accessibility
    };

    // Keyboard navigation (Enter/Space to open, not on focus) - only on toggle
    toggle.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var isMenuOpen = nestedMenu.classList.contains(activeClass);
        if (isMenuOpen) {
          // Menu is open - close it (bypass forceVisible for keyboard)
          hoverInside = false;
          toggle.classList.remove(activeClass);
          nestedMenu.classList.remove(activeClass);
          linkElement.focus(); // Keyboard-only: Return focus to trigger link for accessibility
        } else {
          // Menu is closed - open it
          hoverInside = true;
          showMenu();
        }
      }
    });

    // Attach Escape handler to both toggle and nested menu (like megamenu does)
    toggle.addEventListener('keydown', handleEscape);
    nestedMenu.addEventListener('keydown', handleEscape);
    toggle.addEventListener('focusout', e => {
      var relatedTarget = e.relatedTarget;
      if (!nestedMenu.contains(relatedTarget) && relatedTarget !== toggle) {
        hoverInside = false;
        setTimeout(hideMenu, 50);
      }
    });

    // Hover inside nested menu keeps it active
    nestedMenu.addEventListener('mouseenter', () => {
      hoverInside = true;
      showMenu();
    });

    // Leaving nested menu: only hide if not entering the toggle
    nestedMenu.addEventListener('mouseleave', () => {
      hoverInside = false;
      setTimeout(hideMenu, 50);
    });
  });
}
var initHeaderSearch = () => {
  var searchParent = document.querySelectorAll('[data-search-parent]');
  if (!searchParent.length) return;
  searchParent.forEach(parent => {
    var searchPlaceholder = parent.querySelector('[data-search-placeholder]');
    var showSearchPlaceholder = () => {
      if (!searchPlaceholder) return;
      searchPlaceholder.style.display = 'flex';
    };
    var hideSearchPlaceholder = () => {
      if (!searchPlaceholder) return;
      searchPlaceholder.style.display = 'none';
    };
    var handleSearch = /*#__PURE__*/function () {
      var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (ev) {
        searchResults.innerHTML = '';
        if (ev.target.value.length <= 0) {
          trendingSearches.style.display = 'block';
          searchResults.innerHTML = '';
          hideSearchPlaceholder();
          return;
        }
        trendingSearches.style.display = 'none';
        showSearchPlaceholder();
        var query = ev.target.value;
        var results = yield (0,JsComponents_api_integration_js__WEBPACK_IMPORTED_MODULE_1__.getHeaderSearch)(query);
        var html = results["header-search"];
        hideSearchPlaceholder();
        searchResults.innerHTML = html;
      });
      return function handleSearch(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var handleTrendingSearchClick = ev => {
      var trendingSearchItem = ev.target.closest('[data-trending-search-item]');
      if (trendingSearchItem) {
        var query = trendingSearchItem.dataset.trendingSearchItem;
        searchInput.value = query;
        searchInput.dispatchEvent(new Event('input'));
      }
    };
    var searchInput = parent.querySelector('[data-search-input]');
    if (!searchInput) return;
    var searchResults = parent.querySelector('[data-search-results]');
    if (!searchResults) return;
    var trendingSearches = parent.querySelector('[data-trending-searches]');
    if (trendingSearches) {
      trendingSearches.addEventListener('click', handleTrendingSearchClick);
    }
    searchInput.addEventListener('input', (0,JsComponents_api_integration_js__WEBPACK_IMPORTED_MODULE_1__.debounce)(handleSearch, 500));
    var mobileSearchInput = parent.querySelector('[data-search-input-mobile]');
    if (!mobileSearchInput) return;
    mobileSearchInput.addEventListener('focus', () => {
      if (getCurrentActivePanel() !== 'search') {
        setActivePanel('search');
      }
    });
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  initHeaderMegamenu(root);
  initMobileNestedNav(root);
  initHoverNestedMenu();
  initHoverNestedMenu({
    toggleAttr: "data-megamenu-tab",
    forceVisible: true
  });
  initHeaderSearch();
});

/***/ }),

/***/ "./js/components/migrate-section.js":
/*!******************************************!*\
  !*** ./js/components/migrate-section.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   appendSection: () => (/* binding */ appendSection),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var migrateSection = () => {
  var sections = document.querySelectorAll('[data-migrate-section]');
  sections.forEach(section => {
    var sectionId = section.dataset.migrateSection;
    if (sectionId) {
      var query = "[data-section-target=\"".concat(sectionId, "\"]");
      var targetSection = document.querySelectorAll(query);
      targetSection.forEach(target => {
        target.innerHTML = section.innerHTML;
        section.style.display = 'none';
        // section.remove();
      });
    }
  });
};
var appendSection = () => {
  var sections = document.querySelectorAll('[data-append-section]');
  sections.forEach(section => {
    var sectionId = section.dataset.appendSection;
    if (sectionId) {
      var query = "[data-section-target=\"".concat(sectionId, "\"]");
      var targetSection = document.querySelectorAll(query);
      targetSection.forEach(target => {
        target.insertAdjacentHTML('beforeend', section.innerHTML);
        section.remove();
      });
    }
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (migrateSection);

/***/ }),

/***/ "./js/components/pdf-viewer.js":
/*!*************************************!*\
  !*** ./js/components/pdf-viewer.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var _embedpdf_react_pdf_viewer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @embedpdf/react-pdf-viewer */ "./node_modules/@embedpdf/react-pdf-viewer/dist/index.js");




class PDFViewerElement extends HTMLElement {
  constructor() {
    super(...arguments);
    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(this, "root", null);
    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(this, "container", null);
  }
  connectedCallback() {
    if (this.root) return;
    var pdfUrl = this.getAttribute('data-pdf-url');
    if (!pdfUrl) return;
    var height = this.getAttribute('data-height') || '600px';
    var themePreference = this.getAttribute('data-theme-preference') || 'system';
    this.container = document.createElement('div');
    this.container.style.height = height;
    this.container.style.width = '100%';
    this.appendChild(this.container);
    this.root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_2__.createRoot)(this.container);
    this.root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_embedpdf_react_pdf_viewer__WEBPACK_IMPORTED_MODULE_3__.PDFViewer, {
      config: {
        src: pdfUrl,
        theme: {
          preference: themePreference
        },
        disabledCategories: ['document-open', 'document-close', 'document-protect'],
        zoom: {
          defaultZoomLevel: 1.5 // 150% zoom
        }
      },
      onReady: registry => {
        // Set zoom to 150% after document loads
        if (registry && registry.plugins) {
          setTimeout(() => {
            try {
              var _zoomPlugin$_capabili;
              var zoomPlugin = registry.plugins.get('zoom');
              if (zoomPlugin !== null && zoomPlugin !== void 0 && (_zoomPlugin$_capabili = zoomPlugin._capability) !== null && _zoomPlugin$_capabili !== void 0 && _zoomPlugin$_capabili.requestZoom) {
                var _registry$store;
                // Get document ID from registry store
                var documentId = null;
                if ((_registry$store = registry.store) !== null && _registry$store !== void 0 && _registry$store.getState) {
                  var _state$core, _state$core2;
                  var state = registry.store.getState();
                  documentId = (state === null || state === void 0 || (_state$core = state.core) === null || _state$core === void 0 ? void 0 : _state$core.activeDocumentId) || (state !== null && state !== void 0 && (_state$core2 = state.core) !== null && _state$core2 !== void 0 && _state$core2.documents ? Object.keys(state.core.documents)[0] : null);
                }

                // Set zoom to 150%
                if (documentId) {
                  zoomPlugin._capability.requestZoom(1.5, documentId);
                } else {
                  zoomPlugin._capability.requestZoom(1.5);
                }
              }
            } catch (error) {
              console.warn('[PDFViewerElement] Error setting zoom:', error);
            }
          }, 1500);
        }
      },
      onInit: container => {
        // Viewer initialized
      },
      style: {
        width: '100%',
        height: '100%'
      }
    }));
  }
  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
    this.container = null;
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PDFViewerElement);

/***/ }),

/***/ "./js/components/scroll-tab.js":
/*!*************************************!*\
  !*** ./js/components/scroll-tab.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var scrollTab = () => {
  var scrollTabSections = document.querySelectorAll('[data-scroll-tabs-list]');

  // Helper function to detect mobile
  var isMobile = () => window.innerWidth < 1024;
  scrollTabSections.forEach(section => {
    var scrollTabButton = section.querySelectorAll('[data-tab]');
    var contentTargets = section.querySelectorAll('[data-section-target]');
    if (scrollTabButton.length === 0 || contentTargets.length === 0) return;

    // Track current active tab to prevent unnecessary switches
    var currentActiveTabId = null;

    // Track user-initiated clicks to prevent Intersection Observer from overriding
    var userInitiatedTabChange = false;
    var userInitiatedTimeout = null;

    // Get screen reader announcer element
    var sectionId = section.id.replace('shopify-section-', '');
    var announcer = section.querySelector("#scroll-tabs-announcer-".concat(sectionId));

    // Helper function to announce to screen readers
    var announceToScreenReader = message => {
      if (announcer) {
        announcer.textContent = message;
        // Clear after announcement to allow re-announcement
        setTimeout(() => {
          announcer.textContent = '';
        }, 1000);
      }
    };

    // Get offsets based on device type
    var getScrollOffset = () => isMobile() ? 200 : 100;
    var getObserverOffset = () => isMobile() ? '-160px 0px -50% 0px' : '-120px 0px -50% 0px';

    // Helper function to get all tab buttons in order
    var getAllTabButtons = () => {
      return Array.from(section.querySelectorAll('[data-tab]'));
    };

    // Helper function to get tab index
    var getTabIndex = button => {
      var allButtons = getAllTabButtons();
      // Remove duplicates by tab ID
      var uniqueTabIds = [...new Set(allButtons.map(btn => btn.dataset.tabButton))];
      return uniqueTabIds.indexOf(button.dataset.tabButton);
    };

    // Helper function to get tab button by index
    var getTabButtonByIndex = index => {
      var allButtons = getAllTabButtons();
      var uniqueTabIds = [...new Set(allButtons.map(btn => btn.dataset.tabButton))];
      if (index < 0 || index >= uniqueTabIds.length) return null;
      return section.querySelector("[data-tab=\"".concat(uniqueTabIds[index], "\"]"));
    };

    // Helper function to update tabindex for all buttons
    var updateTabIndexes = activeButton => {
      return;
      // removed by dead control flow
 var allButtons; 
      // removed by dead control flow
 var uniqueTabIds; 
      // removed by dead control flow

    };

    // Helper function to scroll to content and activate tab
    var scrollToTabContent = function scrollToTabContent(tabId) {
      var announce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var isUserInitiated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var tabContentQuery = "[data-section-target=\"".concat(tabId, "\"]");
      var tabContent = section.querySelector(tabContentQuery);
      if (!tabContent) return;

      // Mark as user-initiated if it's a click
      if (isUserInitiated) {
        userInitiatedTabChange = true;
        // Clear any existing timeout
        if (userInitiatedTimeout) {
          clearTimeout(userInitiatedTimeout);
        }
        // Reset flag after scroll completes (smooth scroll takes ~500ms)
        userInitiatedTimeout = setTimeout(() => {
          userInitiatedTabChange = false;
        }, 800); // 800ms to account for scroll animation + buffer
      }
      var headerOffset = getScrollOffset();
      var elementPosition = tabContent.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      // Debounce tab activation on click to prevent jumping
      if (isUserInitiated) {
        debouncedActivateTab(tabId, true, announce);
      } else {
        activateTabButton(tabId, true, announce);
      }
    };

    // Helper function to activate a tab button by tab_id
    var activateTabButton = function activateTabButton(tabId) {
      var scrollSwiper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var announce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // Prevent switching to the same tab
      if (currentActiveTabId === tabId) return;

      // Find ALL tab buttons with this ID (there may be multiple - desktop/mobile versions)
      var tabButtons = section.querySelectorAll("[data-tab=\"".concat(tabId, "\"]"));
      if (tabButtons.length === 0) return;

      // Get tab title for screen reader announcement
      var tabTitle = tabButtons[0].getAttribute('aria-label') || tabButtons[0].textContent.trim();

      // Deactivate all tab buttons in this section
      scrollTabButton.forEach(btn => {
        btn.classList.remove('active');
      });

      // Activate ALL matching tab buttons with the same ID
      tabButtons.forEach(tabButton => {
        tabButton.classList.add('active');
      });

      // Update tabindex
      if (tabButtons.length > 0) {
        updateTabIndexes(tabButtons[0]);
      }
      currentActiveTabId = tabId;

      // Announce to screen readers
      if (announce && tabTitle) {
        announceToScreenReader("Tab activated: ".concat(tabTitle));
      }

      // Find and activate the swiper slide for ALL active buttons
      // (need to scroll all swipers - desktop and mobile)
      if (scrollSwiper && tabButtons.length > 0) {
        var processedSwipers = new WeakSet(); // Track which swiper instances we've already processed

        tabButtons.forEach(tabButton => {
          var swiperSlide = tabButton.closest('.swiper-slide');
          if (!swiperSlide) return;

          // Find the carousel-swiper custom element
          var carouselSwiper = tabButton.closest('carousel-swiper');
          var swiper = null;
          var slideIndex = -1;
          if (carouselSwiper && carouselSwiper.swiper) {
            swiper = carouselSwiper.swiper;
            slideIndex = Array.from(swiperSlide.parentElement.children).indexOf(swiperSlide);
          } else {
            // Fallback: try to find swiper instance on the container
            var swiperContainer = swiperSlide.closest('.swiper');
            if (swiperContainer && swiperContainer.swiper) {
              swiper = swiperContainer.swiper;
              slideIndex = Array.from(swiperSlide.parentElement.children).indexOf(swiperSlide);
            }
          }

          // Slide to the active tab button (only if we haven't processed this swiper instance yet)
          if (swiper && slideIndex !== -1 && !processedSwipers.has(swiper)) {
            processedSwipers.add(swiper);
            swiper.slideTo(slideIndex, 300); // 300ms animation
          }
        });
      }
    };

    // Click handler: Scroll to corresponding content section
    scrollTabButton.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        var tabId = button.dataset.tab;
        scrollToTabContent(tabId, true, true); // Mark as user-initiated
      });
    });

    // Keyboard navigation handler
    scrollTabButton.forEach(button => {
      button.addEventListener('keydown', e => {
        var allButtons = getAllTabButtons();
        var uniqueTabIds = [...new Set(allButtons.map(btn => btn.dataset.tabButton))];
        var currentIndex = getTabIndex(button);
        var targetIndex = currentIndex;
        var shouldPreventDefault = false;

        // Determine orientation based on tablist
        var tablist = button.closest('[role="tablist"]');
        var orientation = (tablist === null || tablist === void 0 ? void 0 : tablist.getAttribute('aria-orientation')) || (isMobile() ? 'horizontal' : 'vertical');
        switch (e.key) {
          case 'ArrowRight':
            if (orientation === 'horizontal') {
              targetIndex = (currentIndex + 1) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'ArrowLeft':
            if (orientation === 'horizontal') {
              targetIndex = (currentIndex - 1 + uniqueTabIds.length) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'ArrowDown':
            if (orientation === 'vertical') {
              targetIndex = (currentIndex + 1) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'ArrowUp':
            if (orientation === 'vertical') {
              targetIndex = (currentIndex - 1 + uniqueTabIds.length) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'Home':
            targetIndex = 0;
            shouldPreventDefault = true;
            break;
          case 'End':
            targetIndex = uniqueTabIds.length - 1;
            shouldPreventDefault = true;
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            var tabId = button.dataset.tabButton;
            scrollToTabContent(tabId, true, true); // Mark as user-initiated
            return;
        }
        if (shouldPreventDefault) {
          e.preventDefault();
          var targetButton = getTabButtonByIndex(targetIndex);
          if (targetButton) {
            targetButton.focus();
            var _tabId = targetButton.dataset.tabButton;
            scrollToTabContent(_tabId, true, true); // Mark as user-initiated
          }
        }
      });
    });

    // Debounce function to prevent rapid switching
    var debounceTimeout = null;
    var debouncedActivateTab = function debouncedActivateTab(tabId) {
      var scrollSwiper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var announce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        activateTabButton(tabId, scrollSwiper, announce);
      }, 150); // 150ms debounce delay
    };

    // Intersection Observer: Activate tab when content section is in viewport
    var observerOptions = {
      root: null,
      rootMargin: getObserverOffset(),
      // Different offset for mobile/desktop
      threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
    };

    // Create observer callback
    var observerCallback = entries => {
      // Don't override user-initiated tab changes
      if (userInitiatedTabChange) return;

      // Find entries that are intersecting (in viewport with offset)
      var intersectingEntries = entries.filter(entry => entry.isIntersecting);
      if (intersectingEntries.length === 0) return;

      // If multiple entries are intersecting, choose the one with highest intersection ratio
      // (most visible in viewport)
      var mostVisibleEntry = null;
      var maxRatio = 0;
      intersectingEntries.forEach(entry => {
        if (entry.intersectionRatio > maxRatio) {
          maxRatio = entry.intersectionRatio;
          mostVisibleEntry = entry;
        }
      });

      // Activate the tab for the most visible intersecting entry
      if (mostVisibleEntry) {
        var tabId = mostVisibleEntry.target.getAttribute('data-section-target');
        if (tabId) {
          debouncedActivateTab(tabId); // Use debounced activation
        }
      }
    };

    // Create observer
    var observer = new IntersectionObserver(observerCallback, observerOptions);

    // Update observer on resize to use correct offset
    var resizeTimeout;
    var updateObserverOptions = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Disconnect current observer
        observer.disconnect();
        // Update options with new offset
        observerOptions.rootMargin = getObserverOffset();
        // Recreate observer with new options
        observer = new IntersectionObserver(observerCallback, observerOptions);
        // Re-observe all targets
        contentTargets.forEach(target => {
          observer.observe(target);
        });
      }, 250);
    };
    window.addEventListener('resize', updateObserverOptions);

    // Observe all content target elements
    contentTargets.forEach(target => {
      observer.observe(target);
    });

    // Initial check on load
    var checkInitialActive = () => {
      var offset = getScrollOffset();
      var viewportCenter = window.innerHeight / 2 + offset;
      var activeTarget = null;
      var minDistance = Infinity;
      contentTargets.forEach(target => {
        var rect = target.getBoundingClientRect();
        var targetCenter = rect.top + rect.height / 2;
        var distance = Math.abs(targetCenter - viewportCenter);

        // Check if target is in viewport and closest to center
        if (rect.top < viewportCenter && rect.bottom > viewportCenter) {
          if (distance < minDistance) {
            minDistance = distance;
            activeTarget = target;
          }
        }
      });
      if (activeTarget) {
        var tabId = activeTarget.getAttribute('data-section-target');
        if (tabId) {
          activateTabButton(tabId, true, false); // Scroll swiper to show active tab, don't announce on initial load
        }
      } else {
        var _contentTargets$;
        // If no active target, set first tab as active
        var firstTabId = (_contentTargets$ = contentTargets[0]) === null || _contentTargets$ === void 0 ? void 0 : _contentTargets$.getAttribute('data-section-target');
        if (firstTabId) {
          activateTabButton(firstTabId, true, false);
        }
      }
    };

    // Run initial check after a short delay to ensure DOM and swiper are ready
    setTimeout(checkInitialActive, 500);
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (scrollTab);

/***/ }),

/***/ "./js/components/stepped-form.js":
/*!***************************************!*\
  !*** ./js/components/stepped-form.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initSteppedForm)
/* harmony export */ });
/* unused harmony exports handleFormSuccess, handleFormError */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _form_validation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./form-validation */ "./js/components/form-validation.js");
/* harmony import */ var _api_integration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api-integration */ "./js/components/api-integration.js");




var handleFormSuccess = function handleFormSuccess(formOrContainer) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "UI";
  var redirectUrl = arguments.length > 2 ? arguments[2] : undefined;
  if (mode === "redirect" && redirectUrl) {
    window.location.href = redirectUrl;
    return;
  }
  if (!formOrContainer) {
    console.error('handleFormSuccess: formOrContainer is null or undefined');
    return;
  }
  var successContainers = formOrContainer.querySelectorAll('[data-stepped-form-success]');
  if (successContainers.length === 0) {
    console.warn('handleFormSuccess: No success containers found');
    return;
  }

  // Hide form body and footer when showing success
  var formBody = formOrContainer.querySelector('.stepped-form-body');
  var formFooter = formOrContainer.querySelector('.stepped-form-footer');
  var formHeader = formOrContainer.querySelector('.stepped-form-header');
  if (formBody) formBody.classList.add('tw-hidden');
  if (formFooter) formFooter.classList.add('tw-hidden');
  if (formHeader) formHeader.classList.add('tw-hidden');
  successContainers.forEach(successContainer => {
    if (successContainer) {
      successContainer.classList.remove('tw-hidden');
      successContainer.classList.add('tw-block');
      // Scroll to success message
      successContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
};
var handleFormError = (formOrContainer, errorMessage) => {
  // Support both regular forms and stepped forms (container)
  var errorContainers = formOrContainer.querySelectorAll('[data-stepped-form-error]');
  errorContainers.forEach(errorContainer => {
    errorContainer.textContent = errorMessage;
    errorContainer.classList.toggle('tw-hidden', !errorMessage);
    errorContainer.classList.toggle('tw-block', !!errorMessage);
  });
  console.log('Form error:', errorMessage);
};
function initSteppedForm() {
  var containerSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[stepped-form-container]';
  // Support multiple forms on the page
  var containers = [...document.querySelectorAll(containerSelector)];
  if (!containers.length) return;
  containers.forEach(container => {
    var steps = [...container.querySelectorAll('[data-step-index]')];
    if (!steps.length) return;
    var nextBtn = container.querySelector('[data-step-next]');
    var prevBtn = container.querySelector('[data-step-previous]');
    var submitBtn = container.querySelector('[data-step-submit]');
    var totalSteps = steps.length;
    var currentStepIndex = 1; // start at step 1
    var formDataStore = {}; // store form data across steps

    // STEP VISIBILITY
    var updateStepVisibility = () => {
      var _container$querySelec;
      var currentActive = steps.find(s => s.classList.contains('tw-block'));
      var activeStep = steps.find(s => Number(s.dataset.stepIndex) === currentStepIndex);
      var errorContainer = container.querySelector('[data-stepped-form-error]');
      if (errorContainer) {
        errorContainer.classList.add('tw-hidden');
      }
      if (currentActive) {
        currentActive.classList.remove('tw-block');
        currentActive.classList.add('tw-hidden');
      }
      if (activeStep) {
        activeStep.classList.remove('tw-hidden');
        activeStep.classList.add('tw-block');
      }
      var inputs = activeStep.querySelectorAll('input, textarea, select');
      (0,_form_validation__WEBPACK_IMPORTED_MODULE_1__.initFormInputListeners)(inputs);

      // Disable previous button
      if (prevBtn) {
        var button = prevBtn.querySelector('button, a');
        if (button) {
          button.disabled = currentStepIndex === 1;
          button.setAttribute('data-button-disabled', currentStepIndex === 1 ? 'true' : 'false');
        }
      }

      // Next and submit buttons toggle visibility
      nextBtn === null || nextBtn === void 0 || nextBtn.classList.toggle('tw-hidden', currentStepIndex === totalSteps);
      submitBtn === null || submitBtn === void 0 || submitBtn.classList.toggle('tw-hidden', currentStepIndex !== totalSteps);

      // Progress bar update
      var progressPercentage = currentStepIndex / totalSteps * 100;
      (_container$querySelec = container.querySelector('[data-progress-bar]')) === null || _container$querySelec === void 0 || _container$querySelec.style.setProperty('width', "".concat(progressPercentage, "%"));
      var percentageText = container.querySelector('[data-percentage-text]');
      if (percentageText) percentageText.textContent = "".concat(Math.round(progressPercentage), "%");
      var stepText = container.querySelector('[data-step-text]');
      if (stepText) stepText.textContent = "Step ".concat(currentStepIndex, " of ").concat(totalSteps);
    };

    // VALIDATE STEP (pure)
    var validateStep = step => {
      var _step$querySelector;
      var formId = (_step$querySelector = step.querySelector('[data-form-id]')) === null || _step$querySelector === void 0 ? void 0 : _step$querySelector.dataset.formId;
      if (!formId) return true;
      var data = (0,_form_validation__WEBPACK_IMPORTED_MODULE_1__.validateFormById)(formId);
      if (!data) return false;
      formDataStore[formId] = data;
      return true;
    };

    // BUTTON EVENTS
    nextBtn === null || nextBtn === void 0 || nextBtn.addEventListener('click', () => {
      var currentStep = steps.find(s => Number(s.dataset.stepIndex) === currentStepIndex);
      if (!validateStep(currentStep)) return;
      if (currentStepIndex < totalSteps) currentStepIndex++;
      updateStepVisibility();
    });
    prevBtn === null || prevBtn === void 0 || prevBtn.addEventListener('click', () => {
      if (currentStepIndex > 1) currentStepIndex--;
      updateStepVisibility();
    });
    submitBtn === null || submitBtn === void 0 || submitBtn.addEventListener('click', /*#__PURE__*/function () {
      var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (e) {
        e.preventDefault();
        var currentStep = steps.find(s => Number(s.dataset.stepIndex) === currentStepIndex);
        if (!validateStep(currentStep)) return;
        console.log(formDataStore, 'final data');
        (0,_form_validation__WEBPACK_IMPORTED_MODULE_1__.toggleSubmitButtonLoading)(submitBtn, true);
        try {
          var url = container.dataset.formUrl;
          var method = container.dataset.formMethod || 'POST';
          var response = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_2__.submitAdaptHealthForm)({
            url,
            method,
            data: formDataStore
          });
          if (response !== null && response !== void 0 && response.error) {
            (0,_form_validation__WEBPACK_IMPORTED_MODULE_1__.toggleSubmitButtonLoading)(submitBtn, false);
            handleFormError(container, response.text);
            return;
          }
          handleFormSuccess(container);
        } catch (err) {
          console.error('Stepped form submit error:', err);
          (0,_form_validation__WEBPACK_IMPORTED_MODULE_1__.toggleSubmitButtonLoading)(submitBtn, false);
          handleFormError(container, 'Failed to submit form. Please try again later.');
        }
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    // INITIALIZE
    updateStepVisibility();
  });
}

/***/ }),

/***/ "./js/components/stock-info.js":
/*!*************************************!*\
  !*** ./js/components/stock-info.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   updateAllStockfields: () => (/* binding */ updateAllStockfields)
/* harmony export */ });
/* unused harmony exports fetchStockQuote, parseStockQuoteData, updateStockfields */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
/* harmony import */ var _api_integration_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api-integration.js */ "./js/components/api-integration.js");




//  API CLIENT
var b2iStockQuoteClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
  baseURL: 'https://www.b2i.us',
  timeout: 10000 //10 seconds
});
var B2I_CONFIG = {
  bizID: '2426'
};

//  Fetch Stock Quote (API)
var fetchStockQuote = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (symbol) {
    if (!symbol || !symbol.trim()) {
      return (0,_api_integration_js__WEBPACK_IMPORTED_MODULE_2__.handleApiError)(new Error('Stock symbol is required'));
    }
    var normalizedSymbol = symbol.trim().toUpperCase();
    var localStorageKey = "stockQuote_".concat(normalizedSymbol);
    var cachedData = localStorage.getItem(localStorageKey);
    if (cachedData) {
      refreshStockQuote(normalizedSymbol, localStorageKey);
      return JSON.parse(cachedData);
    }
    return yield refreshStockQuote(normalizedSymbol, localStorageKey);
  });
  return function fetchStockQuote(_x) {
    return _ref.apply(this, arguments);
  };
}();
var refreshStockQuote = /*#__PURE__*/function () {
  var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (symbol, localStorageKey) {
    try {
      var response = yield b2iStockQuoteClient.get('/b2i/quote3.asp', {
        params: {
          b: B2I_CONFIG.bizID,
          S: symbol,
          L: 1
        }
      });
      var result = {
        success: true,
        data: response.data,
        symbol
      };
      localStorage.setItem(localStorageKey, JSON.stringify(result));
      return result;
    } catch (error) {
      return (0,_api_integration_js__WEBPACK_IMPORTED_MODULE_2__.handleApiError)(error, 'Failed to fetch stock quote');
    }
  });
  return function refreshStockQuote(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

//  Parse Stock Quote Data (API)
var parseStockQuoteData = jsText => {
  if (!jsText) return null;

  // Parse all variable assignments in one pass
  var varPattern = /var\s+(\w+)\s*=\s*'([^']*)'/g;
  var data = {};
  var match;
  while ((match = varPattern.exec(jsText)) !== null) {
    data[match[1]] = match[2];
  }
  var changePercent = data.b2iChangePercent;
  var changeRawValue = data.b2iChange;

  // Format changeRaw: "$0.34" or "-$0.03"
  var changeRaw = changeRawValue ? parseFloat(changeRawValue) >= 0 ? "$".concat(changeRawValue) : "-$".concat(Math.abs(parseFloat(changeRawValue))) : null;

  // Format change: "$0.34 (+3.91%)" or "-$0.03 (-0.28%)"
  var change = changeRawValue && changePercent ? parseFloat(changeRawValue) >= 0 ? "$".concat(changeRawValue, " (").concat(changePercent, ")") : "-$".concat(Math.abs(parseFloat(changeRawValue)), " (").concat(changePercent, ")") : changePercent || null;

  // Format timestamp for normal use: "4:00PM 10/14/2025" (time first)
  var stock_timestamp = data.b2iLastDate && data.b2iLastTime ? "".concat(data.b2iLastTime, " ").concat(data.b2iLastDate) : null;

  // Format timestamp for table: "01/20/2026 4:00PM" (date first, MM/DD/YYYY format)
  var stock_timestamp_table = null;
  if (data.b2iLastDate && data.b2iLastTime) {
    // Parse date from "January 20, 2026" format and convert to "01/20/2026"
    var dateObj = new Date(data.b2iLastDate);
    if (!isNaN(dateObj.getTime())) {
      var month = String(dateObj.getMonth() + 1).padStart(2, '0');
      var day = String(dateObj.getDate()).padStart(2, '0');
      var year = dateObj.getFullYear();
      var formattedDate = "".concat(month, "/").concat(day, "/").concat(year);
      stock_timestamp_table = "".concat(formattedDate, " ").concat(data.b2iLastTime);
    } else {
      // Fallback to original format if parsing fails
      stock_timestamp_table = "".concat(data.b2iLastDate, " ").concat(data.b2iLastTime);
    }
  }

  // Format bid and ask with sizes (e.g., "$8.61x200")
  var bid = data.b2iBid && data.b2iBidSz ? "$".concat(data.b2iBid, "x").concat(data.b2iBidSz) : data.b2iBid || null;
  var ask = data.b2iAsk && data.b2iAskSz ? "$".concat(data.b2iAsk, "x").concat(data.b2iAskSz) : data.b2iAsk || null;
  return {
    price: "$".concat(data.b2iLastPrice),
    volume: data.b2iVolume,
    marketCap: data.b2ifMcap ? "$".concat(data.b2ifMcap) : null,
    change: change,
    // Formatted as "$0.34 (+3.91%)"
    changeRaw: changeRaw,
    // Raw change value (e.g., '-$0.03')
    open: "$".concat(data.b2iOpenPrice),
    previousClose: "$".concat(data.b2iLastClose),
    intradayHigh: "$".concat(data.b2iDayHigh),
    intradayLow: "$".concat(data.b2iDayLow),
    week52High: "$".concat(data.b2iYearHigh),
    week52Low: "$".concat(data.b2iYearLow),
    bid: bid,
    ask: ask,
    bidSize: data.b2iBidSz,
    askSize: data.b2iAskSz,
    b2iLastDate: data.b2iLastDate,
    b2iLastTime: data.b2iLastTime,
    stock_timestamp: stock_timestamp,
    // Normal format: "4:00PM 10/14/2025"
    stock_timestamp_table: stock_timestamp_table,
    // Table format: "10/14/2025 4:00PM"
    changePercent: changePercent,
    isUp: changePercent ? !changePercent.startsWith('-') : false,
    isDown: changePercent ? changePercent.startsWith('-') : false
  };
};

//  Update Stock Arrow (Logic)
var updateStockArrow = (element, quoteData) => {
  var container = element === null || element === void 0 ? void 0 : element.querySelector('[data-quote-change-container]');
  if (!container) return;
  var arrow = container.querySelector('[data-quote-arrow-up]') || container.querySelector('[data-quote-arrow-down]');
  var changeText = container.querySelector('[data-quote-field="change"]');
  if (!arrow || !changeText) return;
  var isUp = quoteData.isUp;
  arrow.style.transform = isUp ? 'rotate(0deg)' : 'rotate(180deg)';
  arrow.classList.toggle('tw-text-green-500', isUp);
  arrow.classList.toggle('tw-text-red-500', !isUp);
  changeText.classList.toggle('tw-text-green-500', isUp);
  changeText.classList.toggle('tw-text-red-500', !isUp);
  container.style.opacity = '1';
};

//  Update Change Row Color (Logic)
var updateChangeRowColor = (field, value, fieldKey, quoteData) => {
  if (!field) return;

  // Check if this field (td element) has change row classes
  var isChangeValue = field.classList.contains('stock-info-table__change');
  var isChangePercent = field.classList.contains('stock-info-table__change-percent');
  if (!isChangeValue && !isChangePercent) return;

  // Determine if value is positive or negative
  var isPositive = false;
  if (isChangeValue && fieldKey === 'change') {
    // For change field, use the isUp flag from quoteData
    isPositive = quoteData.isUp || false;
  } else if (isChangePercent && fieldKey === 'changePercent') {
    // For changePercent, use the isUp flag from quoteData
    isPositive = quoteData.isUp || false;
  } else {
    // For other fields, try to parse the value
    var numValue = parseFloat(value === null || value === void 0 ? void 0 : value.toString().replace(/[^0-9.-]/g, ''));
    if (!isNaN(numValue)) {
      isPositive = numValue >= 0;
    }
  }

  // Update color classes - find the span inside the field
  var valueSpan = field.querySelector('span') || field;

  // Ensure the span has the appropriate class for styling
  if (isChangeValue && valueSpan !== field) {
    valueSpan.classList.add('stock-info-table__change-value');
  } else if (isChangePercent && valueSpan !== field) {
    valueSpan.classList.add('stock-info-table__change-percent-value');
  }

  // Remove existing color classes
  valueSpan.classList.remove('tw-text-green-500', 'tw-text-red-500');
  field.classList.remove('negative');

  // Add appropriate color class
  if (isPositive) {
    valueSpan.classList.add('tw-text-green-500');
  } else {
    valueSpan.classList.add('tw-text-red-500');
    field.classList.add('negative');
  }
};

//  Update Single Stock Card
var updateStockfields = (stockElementId, quoteData) => {
  var element = typeof stockElementId === 'string' ? document.getElementById(stockElementId) : stockElementId;
  if (!element || !quoteData) return false;
  Object.entries(quoteData).forEach(_ref3 => {
    var [key, value] = _ref3;
    if (!value) return;
    var field = element.querySelector("[data-quote-field=\"".concat(key, "\"]"));
    if (field) {
      // Update text content - update the span inside the field if it exists
      var valueSpan = field.querySelector('span');
      if (valueSpan) {
        valueSpan.textContent = value;
      } else {
        field.textContent = value;
      }
      // Update color for change rows
      updateChangeRowColor(field, value, key, quoteData);
    }
  });
  if (quoteData.change) {
    updateStockArrow(element, quoteData);
  }
  return true;
};

//  Update All Stock Cards
var updateAllStockfields = /*#__PURE__*/function () {
  var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var quoteElements = document.querySelectorAll('[data-quote-card]');
    if (!quoteElements.length) {
      return {
        success: true,
        updated: 0,
        total: 0
      };
    }
    var updates = [...quoteElements].map(/*#__PURE__*/function () {
      var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (element) {
        var symbol = element.dataset.quoteSymbol;
        if (!symbol) return null;
        var result = yield fetchStockQuote(symbol);
        if (!(result !== null && result !== void 0 && result.data)) return null;
        var parsedData = parseStockQuoteData(result.data);
        if (parsedData) {
          updateStockfields(element, parsedData);
        }
        return parsedData;
      });
      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    yield Promise.allSettled(updates);
    return {
      success: true,
      updated: updates.length,
      total: quoteElements.length
    };
  });
  return function updateAllStockfields() {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./js/components/table-scrollbar.js":
/*!******************************************!*\
  !*** ./js/components/table-scrollbar.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initTableScrollbar)
/* harmony export */ });
/**
 * Table Custom Scrollbar Component
 * Creates a custom scrollbar that controls table horizontal scrolling
 */
function initTableScrollbar() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var tableContainers = root.querySelectorAll('[data-table-scroll]');
  tableContainers.forEach(tableContainer => {
    // Skip if already initialized
    if (tableContainer.dataset.initialized === 'true') {
      return;
    }
    tableContainer.dataset.initialized = 'true';
    var wrapper = tableContainer.closest('.table-block__wrapper');
    if (!wrapper) return;

    // Scrollbar is now outside wrapper (sibling), so find it from the parent container
    var container = wrapper.parentElement;
    var scrollbar = container ? container.querySelector('[data-table-scrollbar]') : null;
    var scrollbarTrack = scrollbar ? scrollbar.querySelector('.table-block__scrollbar-track') : null;
    var scrollbarThumb = scrollbar ? scrollbar.querySelector('[data-table-scrollbar-thumb]') : null;
    if (!scrollbar || !scrollbarTrack || !scrollbarThumb) return;
    var isDragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var lastPaddingState = null;
    var lastMarginState = null;
    var wasAtEnd = false; // Track previous end state for hysteresis
    var wasAtStart = false; // Track previous start state for hysteresis
    var rafId = null; // For requestAnimationFrame debouncing

    // iOS scroll end detection variables
    var lastScrollLeft = 0;
    var sameCount = 0;
    var STALL_FRAMES = 3;

    // iOS-specific function to detect when scroll has reached the end
    function isEndReachedIOS(el) {
      var maxScroll = el.scrollWidth - el.clientWidth;
      var current = Math.round(el.scrollLeft);

      // Must be near the end first
      if (current < maxScroll - 40) {
        sameCount = 0;
        lastScrollLeft = current;
        return false;
      }
      if (current === lastScrollLeft) {
        sameCount++;
      } else {
        sameCount = 0;
      }
      lastScrollLeft = current;
      return sameCount >= STALL_FRAMES;
    }

    // Find the table section container
    var tableSection = wrapper.closest('.table-section');
    // Find table block container with margin control attribute (now on table-block__container)
    var tableBlockContainer = container && container.hasAttribute('data-table-margin-control') ? container : null;
    // Find table-block for margin control (parent of container with data-table-margin-control)
    var tableBlock = tableBlockContainer ? tableBlockContainer.closest('.table-block') : null;

    // Get card border radius from data attribute
    var cardBorderRadius = tableContainer.dataset.cardBorderRadius || '12';

    // Helper function to set border radius on all corners
    var setBorderRadius = (topLeft, topRight, bottomLeft, bottomRight) => {
      var value = val => val + (typeof val === 'number' ? 'px' : '');
      tableContainer.style.setProperty('border-top-left-radius', value(topLeft), 'important');
      tableContainer.style.setProperty('border-top-right-radius', value(topRight), 'important');
      tableContainer.style.setProperty('border-bottom-left-radius', value(bottomLeft), 'important');
      tableContainer.style.setProperty('border-bottom-right-radius', value(bottomRight), 'important');
    };

    // Function to update wrapper border radius based on scroll position (mobile only)
    var updateWrapperBorderRadius = () => {
      var cardRadius = parseFloat(cardBorderRadius) || 12;

      // Desktop: apply border radius on all corners
      if (window.innerWidth >= 768) {
        setBorderRadius(cardRadius, cardRadius, cardRadius, cardRadius);
        return;
      }
      var {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = tableContainer;
      var scrollableWidth = scrollWidth - clientWidth;

      // No scroll: apply border radius on all corners
      if (scrollableWidth <= 0) {
        setBorderRadius(cardRadius, cardRadius, cardRadius, cardRadius);
        return;
      }

      // Use hysteresis to prevent flickering during slow scroll
      var threshold = 2;
      var startThresholdEnter = threshold; // 2px - easy to enter start
      var startThresholdExit = threshold + 4; // 6px - harder to exit start
      var endThresholdEnter = threshold + 12; // 14px - easy to enter end
      var endThresholdExit = threshold + 8; // 10px - harder to exit end

      // Check start position with hysteresis
      var isAtStart;
      if (wasAtStart) {
        isAtStart = scrollLeft <= startThresholdExit;
      } else {
        isAtStart = scrollLeft <= startThresholdEnter;
      }

      // Check end position with hysteresis
      var distanceFromEnd = scrollWidth - (scrollLeft + clientWidth);
      var isAtEnd;
      if (wasAtEnd) {
        isAtEnd = distanceFromEnd <= endThresholdExit;
      } else {
        isAtEnd = distanceFromEnd <= endThresholdEnter;
      }
      wasAtStart = isAtStart;
      wasAtEnd = isAtEnd;

      // Apply border radius based on position
      if (isAtStart) {
        setBorderRadius(cardRadius, 0, cardRadius, 0); // Left side only
      } else if (isAtEnd) {
        setBorderRadius(0, cardRadius, 0, cardRadius); // Right side only
      } else {
        setBorderRadius(0, 0, 0, 0); // No border radius
      }
    };

    // Update scrollbar thumb position and size
    var updateScrollbar = () => {
      var {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = tableContainer;
      var trackWidth = scrollbarTrack.offsetWidth + 12;

      // Calculate thumb width based on visible vs scrollable ratio
      var scrollableWidth = scrollWidth - clientWidth;
      if (scrollableWidth <= 0) {
        scrollbar.style.display = 'none';
        // Reset padding when no scroll (only for screens below 768px)
        if (tableSection && window.innerWidth < 768) {
          tableSection.style.paddingRight = '0';
          lastPaddingState = '0';
        }
        // Reset margin for content-card tables
        if (tableBlock && window.innerWidth < 768) {
          tableBlock.style.marginRight = '0';
          lastMarginState = '0';
        }
        wasAtEnd = false; // Reset end state when no scroll
        wasAtStart = false; // Reset start state when no scroll
        // Apply border radius when no scroll needed
        updateWrapperBorderRadius();
        return;
      }
      scrollbar.style.display = 'block';
      var thumbWidth = Math.max(clientWidth / scrollWidth * trackWidth, 50);
      scrollbarThumb.style.width = "".concat(thumbWidth, "px");

      // Calculate thumb position
      var maxThumbLeft = trackWidth - thumbWidth;
      var thumbLeft = scrollLeft / scrollableWidth * maxThumbLeft;
      scrollbarThumb.style.left = "".concat(thumbLeft, "px");

      // Use hysteresis to prevent flickering during slow scroll
      // Different thresholds for entering vs leaving end state
      var threshold = 2;
      var endThresholdEnter = threshold + 12; // 14px - easier to enter end state
      var endThresholdExit = threshold + 6; // 8px - harder to exit end state (prevents flicker)

      // Check if we're at the end using hysteresis
      var distanceFromEnd = scrollWidth - (scrollLeft + clientWidth);
      var isAtEnd;
      if (wasAtEnd) {
        // If we were at end, use exit threshold (harder to leave)
        isAtEnd = distanceFromEnd <= endThresholdExit;
      } else {
        // If we weren't at end, use enter threshold (easier to enter)
        isAtEnd = distanceFromEnd <= endThresholdEnter;
      }

      // Update padding/margin based on current state
      // Only update if state changed to prevent unnecessary DOM updates
      if (wasAtEnd !== isAtEnd) {
        wasAtEnd = isAtEnd;
      }

      // Always update padding/margin to match current state (but only if value changed)
      if (window.innerWidth < 768) {
        // Update padding-right on table section with progressive padding
        if (tableSection) {
          // Calculate progressive padding that increases as we approach the end
          var maxPadding = 20; // Maximum padding in pixels
          var paddingStartDistance = 30; // Start adding padding when 30px from end
          var endPadding = 0;
          if (distanceFromEnd < paddingStartDistance) {
            // Progressive padding: more padding as we get closer to the end
            var paddingRatio = 1 - distanceFromEnd / paddingStartDistance;
            endPadding = Math.max(0, Math.min(maxPadding, maxPadding * paddingRatio));
          }
          var newPaddingState = "".concat(endPadding, "px");
          if (lastPaddingState !== newPaddingState) {
            tableSection.style.paddingRight = newPaddingState;
            lastPaddingState = newPaddingState;
          }
        }

        // Update margin-right on content-card table block with progressive margin
        if (tableBlock) {
          // Calculate progressive margin that decreases as we approach the end
          // Margin goes from -20px (when far from end) to 0px (when at end)
          var maxMargin = 20; // Maximum margin in pixels (negative value)
          var marginStartDistance = 30; // Start changing margin when 30px from end
          var endMargin = -maxMargin; // Start with -20px

          if (distanceFromEnd < marginStartDistance) {
            // Progressive margin: less negative margin as we get closer to the end
            var marginRatio = 1 - distanceFromEnd / marginStartDistance;
            endMargin = -maxMargin + maxMargin * marginRatio; // Goes from -20px to 0px
          }
          var newMarginState = "".concat(endMargin, "px");
          if (lastMarginState !== newMarginState) {
            tableBlock.style.marginRight = newMarginState;
            lastMarginState = newMarginState;
          }
        }
      } else {
        // Desktop: Clean up mobile styles
        if (tableSection && lastPaddingState !== null) {
          tableSection.style.paddingRight = '';
          lastPaddingState = null;
        }
        if (tableBlock && lastMarginState !== null) {
          tableBlock.style.marginRight = '';
          lastMarginState = null;
        }
      }

      // Update wrapper border radius based on scroll position (mobile only)
      updateWrapperBorderRadius();
    };

    // Scroll table to position
    var scrollTo = scrollLeft => {
      tableContainer.scrollLeft = scrollLeft;
      updateScrollbar();
    };

    // Handle thumb drag start
    var handleThumbMouseDown = e => {
      isDragging = true;
      startX = e.clientX || e.touches[0].clientX;
      startScrollLeft = tableContainer.scrollLeft;
      e.preventDefault();
      e.stopPropagation();
    };

    // Handle thumb drag
    var handleThumbMouseMove = e => {
      if (!isDragging) return;
      var currentX = e.clientX || e.touches[0].clientX;
      var deltaX = currentX - startX;
      var trackWidth = scrollbarTrack.offsetWidth;
      var thumbWidth = scrollbarThumb.offsetWidth;
      var maxThumbLeft = trackWidth - thumbWidth;

      // Calculate scroll position
      var {
        scrollWidth,
        clientWidth
      } = tableContainer;
      var scrollableWidth = scrollWidth - clientWidth;
      var thumbDeltaRatio = deltaX / maxThumbLeft;
      var scrollDelta = thumbDeltaRatio * scrollableWidth;
      scrollTo(startScrollLeft + scrollDelta);
    };

    // Handle thumb drag end
    var handleThumbMouseUp = () => {
      isDragging = false;
    };

    // Handle track click
    var handleTrackClick = e => {
      if (e.target === scrollbarThumb) return;
      var trackRect = scrollbarTrack.getBoundingClientRect();
      var clickX = e.clientX - trackRect.left;
      var trackWidth = scrollbarTrack.offsetWidth;
      var thumbWidth = scrollbarThumb.offsetWidth;
      var maxThumbLeft = trackWidth - thumbWidth;

      // Calculate target thumb position (centered on click)
      var targetThumbLeft = clickX - thumbWidth / 2;
      targetThumbLeft = Math.max(0, Math.min(targetThumbLeft, maxThumbLeft));

      // Calculate scroll position
      var {
        scrollWidth,
        clientWidth
      } = tableContainer;
      var scrollableWidth = scrollWidth - clientWidth;
      var scrollRatio = targetThumbLeft / maxThumbLeft;
      var targetScrollLeft = scrollRatio * scrollableWidth;
      scrollTo(targetScrollLeft);
    };

    // Event listeners for thumb dragging
    scrollbarThumb.addEventListener('mousedown', handleThumbMouseDown);
    scrollbarThumb.addEventListener('touchstart', handleThumbMouseDown, {
      passive: false
    });
    document.addEventListener('mousemove', handleThumbMouseMove);
    document.addEventListener('touchmove', handleThumbMouseMove, {
      passive: false
    });
    document.addEventListener('mouseup', handleThumbMouseUp);
    document.addEventListener('touchend', handleThumbMouseUp);

    // Track click
    scrollbarTrack.addEventListener('click', handleTrackClick);

    // const debounce = (func, delay) => {
    //   let timeout;
    //   return function(...args) {
    //     clearTimeout(timeout);
    //     timeout = setTimeout(() => func.apply(this, args), delay);
    //   };
    // };

    function throttle(fn, delay) {
      var lastTime = 0;
      return function () {
        var now = Date.now();
        if (now - lastTime >= delay) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          fn.apply(this, args);
          lastTime = now;
        }
      };
    }

    // Update scrollbar when table scrolls
    tableContainer.addEventListener('scroll', throttle(updateScrollbar, 10));

    // Update scrollbar on resize
    var resizeTimeout;
    var handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateScrollbar();
      }, 100);
    };
    window.addEventListener('resize', handleResize);

    // Initial update
    updateScrollbar();

    // Store cleanup function
    tableContainer._tableScrollbarCleanup = () => {
      scrollbarThumb.removeEventListener('mousedown', handleThumbMouseDown);
      scrollbarThumb.removeEventListener('touchstart', handleThumbMouseDown);
      document.removeEventListener('mousemove', handleThumbMouseMove);
      document.removeEventListener('touchmove', handleThumbMouseMove);
      document.removeEventListener('mouseup', handleThumbMouseUp);
      document.removeEventListener('touchend', handleThumbMouseUp);
      scrollbarTrack.removeEventListener('click', handleTrackClick);
      tableContainer.removeEventListener('scroll', updateScrollbar);
      window.removeEventListener('resize', handleResize);

      // Clean up all applied styles
      if (tableSection) {
        tableSection.style.paddingRight = '';
      }
      if (tableBlock) {
        tableBlock.style.marginRight = '';
      }
      if (wrapper) {
        wrapper.style.paddingRight = '';
      }
      delete tableContainer.dataset.initialized;
    };
  });
}

// Re-initialize for Shopify theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    initTableScrollbar(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    var tableContainers = event.target.querySelectorAll('[data-table-scroll]');
    tableContainers.forEach(container => {
      if (container._tableScrollbarCleanup) {
        container._tableScrollbarCleanup();
      }
    });
  });
}

/***/ }),

/***/ "./js/components/ui-components.js":
/*!****************************************!*\
  !*** ./js/components/ui-components.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initUIComponents: () => (/* binding */ initUIComponents)
/* harmony export */ });
/* unused harmony export attachUIEvents */
// ------------------------------
// UI ACCESSIBLE JS MODULE
// ------------------------------
function attachUIEvents() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  // =========================
  // MODALS
  // =========================
  var modals = root.querySelectorAll('[data-modal]');
  modals.forEach(modal => {
    if (modal.dataset._modalAttached) return;
    modal.dataset._modalAttached = true;
    var modalOpener = null;

    // Backdrop
    var backdrop = modal._backdrop;
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-hidden tw-z-[999999]';
      document.body.appendChild(backdrop);
      modal._backdrop = backdrop;
    }
    var toggleButtons = document.querySelectorAll("[data-modal-toggle=\"".concat(modal.id, "\"]"));
    var hideButtons = modal.querySelectorAll('[data-modal-hide]');
    var openModal = () => {
      var _modal$querySelector;
      modal.classList.remove('tw-hidden');
      backdrop.classList.remove('tw-hidden');

      // Lock background scroll
      document.body.style.overflow = 'hidden';
      (_modal$querySelector = modal.querySelector('button, [tabindex]')) === null || _modal$querySelector === void 0 || _modal$querySelector.focus();
    };
    var closeModal = () => {
      var _modalOpener;
      modal.classList.add('tw-hidden');
      backdrop.classList.add('tw-hidden');

      // Unlock background scroll
      document.body.style.overflow = '';
      (_modalOpener = modalOpener) === null || _modalOpener === void 0 || _modalOpener.focus();
      modalOpener = null;
    };
    toggleButtons.forEach(btn => {
      btn.addEventListener('click', e => {
        modalOpener = e.currentTarget;
        openModal();
      });
      btn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          modalOpener = e.currentTarget;
          openModal();
        }
      });
    });
    hideButtons.forEach(btn => btn.addEventListener('click', closeModal));
    backdrop.addEventListener('click', closeModal);
    modal.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        closeModal();
        return;
      }

      // Get all focusable elements inside the modal
      var focusable = modal.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var firstEl = focusable[0];
      var lastEl = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (!e.shiftKey && document.activeElement === lastEl) {
          // Tab on last element -> close modal
          e.preventDefault();
          closeModal();
        } else if (e.shiftKey && document.activeElement === firstEl) {
          // Shift + Tab on first element -> close modal
          e.preventDefault();
          closeModal();
        }
      }
    });
  });

  // =========================
  // DRAWERS (LEFT ONLY)
  // =========================
  var drawers = root.querySelectorAll('[data-drawer]');
  drawers.forEach(drawer => {
    if (drawer.dataset._drawerAttached) return;
    drawer.dataset._drawerAttached = true;
    var toggleButtons = document.querySelectorAll("[data-drawer-toggle=\"".concat(drawer.id, "\"]"));
    var hideButtons = drawer.querySelectorAll('[data-drawer-hide]');

    // Backdrop
    var backdrop = drawer._backdrop;
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-hidden tw-z-[999]';
      document.body.appendChild(backdrop);
      drawer._backdrop = backdrop;
    }
    drawer.classList.add('tw-fixed', 'tw-top-0', 'tw-left-0', 'tw-h-full', 'tw-bg-white', 'tw-shadow-xl', 'tw-w-72', 'tw-transform', 'tw-translate-x-[-100%]', 'tw-transition-transform', 'tw-duration-300', 'tw-ease-in-out', 'tw-z-[1000]');
    var openDrawer = () => {
      drawer.classList.remove('tw-hidden');
      backdrop.classList.remove('tw-hidden');
      requestAnimationFrame(() => drawer.style.transform = 'translateX(0)');
    };
    var closeDrawer = () => {
      drawer.style.transform = 'translateX(-100%)';
      backdrop.classList.add('tw-hidden');
      setTimeout(() => drawer.classList.add('tw-hidden'), 300);
    };
    toggleButtons.forEach(btn => btn.addEventListener('click', openDrawer));
    hideButtons.forEach(btn => btn.addEventListener('click', closeDrawer));
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !drawer.classList.contains('tw-hidden')) closeDrawer();
    });
  });

  // ------------------------------
  // POPOVER
  // ------------------------------
  // ------------------------------
  // POPOVER
  // ------------------------------
  var popovers = root.querySelectorAll('[data-popover]');

  // Function to close all popovers except the one specified
  var closeAllPopoversExcept = exceptPopover => {
    popovers.forEach(p => {
      if (p !== exceptPopover && !p.classList.contains('tw-hidden')) {
        p.classList.add('tw-hidden');
      }
    });
  };

  // Helper function to get all focusable elements within a container
  var getFocusableElements = container => {
    var focusableSelectors = ['button:not([disabled])', '[href]', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'].join(', ');
    return Array.from(container.querySelectorAll(focusableSelectors)).filter(el => {
      // Filter out elements that are not visible
      return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden' && window.getComputedStyle(el).display !== 'none';
    });
  };
  popovers.forEach(popover => {
    if (popover.dataset._popoverAttached) return;
    popover.dataset._popoverAttached = true;
    var toggleButtons = document.querySelectorAll("[data-popover-toggle=\"".concat(popover.id, "\"]"));
    var hideButtons = popover.querySelectorAll('[data-popover-hide]');

    // Store the last focused element before opening (for returning focus)
    var lastFocusedElement = null;
    var focusTrapHandler = null;
    var tabExitHandler = null;
    var focusInExitHandler = null;
    var openPopover = () => {
      // Close all other popovers first
      closeAllPopoversExcept(popover);
      popover.classList.remove('tw-hidden');

      // Store the currently focused element (the toggle button)
      lastFocusedElement = document.activeElement;

      // Keep focus on trigger button - don't auto-focus first element inside popover

      // Add focus trap for popups that need it (search, login, etc.)
      // Check if this popup should have focus trapping
      var needsFocusTrap = popover.id === 'header-search-popup' || popover.id === 'header-login-popup' || popover.hasAttribute('data-search-parent') || popover.hasAttribute('data-focus-trap');
      if (needsFocusTrap) {
        // Create focus trap handler for Tab key
        focusTrapHandler = e => {
          if (e.key !== 'Tab' || popover.classList.contains('tw-hidden')) return;
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length === 0) return;
          var firstElement = focusableElements[0];
          var lastElement = focusableElements[focusableElements.length - 1];

          // If only one focusable element, keep focus on it
          if (focusableElements.length === 1) {
            e.preventDefault();
            firstElement.focus();
            return;
          }

          // If Shift+Tab on first element, move to last
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
            return;
          }

          // If Tab on last element, close popover and move focus outside
          if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            e.stopPropagation();

            // Find next focusable element after popover
            var allFocusable = Array.from(document.querySelectorAll('button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(el => {
              return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden' && window.getComputedStyle(el).display !== 'none';
            });
            var lastElementIndex = allFocusable.indexOf(lastElement);
            var nextElementToFocus = null;
            if (lastElementIndex >= 0) {
              var _loop = function _loop() {
                var candidateElement = allFocusable[i];
                var isToggleButton = Array.from(toggleButtons).some(btn => btn === candidateElement);
                if (!popover.contains(candidateElement) && !isToggleButton) {
                  nextElementToFocus = candidateElement;
                  return 1; // break
                }
              };
              for (var i = lastElementIndex + 1; i < allFocusable.length; i++) {
                if (_loop()) break;
              }
            }

            // Close popover (skip returning focus to trigger)
            closePopover(true);

            // Focus next element
            if (nextElementToFocus) {
              requestAnimationFrame(() => {
                nextElementToFocus.focus();
              });
            }
            return;
          }

          // If focus is outside the popover, trap it back inside
          if (!popover.contains(document.activeElement)) {
            e.preventDefault();
            firstElement.focus();
          }
        };

        // Create focusin handler to catch any focus that escapes
        var focusInHandler = e => {
          if (popover.classList.contains('tw-hidden')) return;

          // If focus moved to something outside the popover, bring it back
          if (!popover.contains(e.target)) {
            var focusableElements = getFocusableElements(popover);
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
          }
        };

        // Add focus trap event listeners
        popover.addEventListener('keydown', focusTrapHandler);
        document.addEventListener('focusin', focusInHandler);

        // Store the focusin handler for cleanup
        popover._focusInHandler = focusInHandler;
      } else {
        // For popovers without focus trap, allow Tab to exit naturally
        // Tab on last element should close popover and move focus to next element
        tabExitHandler = e => {
          if (e.key !== 'Tab' || e.shiftKey || popover.classList.contains('tw-hidden')) return;
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length === 0) return;
          var lastElement = focusableElements[focusableElements.length - 1];
          var isLastElementFocused = document.activeElement === lastElement;
          if (isLastElementFocused) {
            e.preventDefault();
            e.stopPropagation();

            // Find next focusable element after popover
            var allFocusable = Array.from(document.querySelectorAll('button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(el => {
              return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden' && window.getComputedStyle(el).display !== 'none';
            });
            var lastElementIndex = allFocusable.indexOf(lastElement);
            var nextElementToFocus = null;
            if (lastElementIndex >= 0) {
              var _loop2 = function _loop2() {
                var candidateElement = allFocusable[i];
                var isToggleButton = Array.from(toggleButtons).some(btn => btn === candidateElement);
                if (!popover.contains(candidateElement) && !isToggleButton) {
                  nextElementToFocus = candidateElement;
                  return 1; // break
                }
              };
              for (var i = lastElementIndex + 1; i < allFocusable.length; i++) {
                if (_loop2()) break;
              }
            }

            // Close popover
            closePopover();

            // Focus next element
            if (nextElementToFocus) {
              requestAnimationFrame(() => {
                nextElementToFocus.focus();
              });
            }
          }
        };

        // Handle Shift+Tab on first element - move focus back to toggle
        var handleShiftTab = e => {
          if (e.key !== 'Tab' || !e.shiftKey || popover.classList.contains('tw-hidden')) return;
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length === 0) return;
          var firstElement = focusableElements[0];
          var isFirstElementFocused = document.activeElement === firstElement;
          if (isFirstElementFocused && toggleButtons.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            toggleButtons[0].focus();
          }
        };
        popover.addEventListener('keydown', tabExitHandler, true);
        popover.addEventListener('keydown', handleShiftTab, true);
        popover._tabExitHandler = tabExitHandler;
        popover._handleShiftTab = handleShiftTab;
      }
    };
    var closePopover = function closePopover() {
      var skipFocusReturn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      popover.classList.add('tw-hidden');

      // Remove focus trap handlers
      if (focusTrapHandler) {
        popover.removeEventListener('keydown', focusTrapHandler);
        focusTrapHandler = null;
      }
      if (popover._focusInHandler) {
        document.removeEventListener('focusin', popover._focusInHandler);
        popover._focusInHandler = null;
      }

      // Remove tab exit handlers
      if (tabExitHandler) {
        popover.removeEventListener('keydown', tabExitHandler, true);
        tabExitHandler = null;
      }
      if (popover._handleShiftTab) {
        popover.removeEventListener('keydown', popover._handleShiftTab, true);
        popover._handleShiftTab = null;
      }

      // Return focus to the toggle button that opened it (unless skipping)
      if (!skipFocusReturn && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        setTimeout(() => {
          lastFocusedElement.focus();
          lastFocusedElement = null;
        }, 0);
      } else if (skipFocusReturn) {
        // Clear the last focused element when skipping focus return
        lastFocusedElement = null;
      }
    };

    // Click handler for toggle buttons
    toggleButtons.forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        if (popover.classList.contains('tw-hidden')) {
          openPopover();
        } else {
          closePopover();
        }
      });

      // Keyboard handler for toggle buttons (Enter/Space and Tab)
      btn.addEventListener('keydown', e => {
        var isPopoverOpen = !popover.classList.contains('tw-hidden');
        var isToggleFocused = document.activeElement === btn;

        // Enter/Space: Toggle popover
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          if (isPopoverOpen) {
            closePopover();
          } else {
            openPopover();
          }
          return;
        }

        // Tab: Move focus from toggle to first item in popover when open
        if (e.key === 'Tab' && !e.shiftKey && isPopoverOpen && isToggleFocused) {
          e.preventDefault();
          e.stopPropagation();
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          }
        }
      }, true); // Use capture phase
    });
    hideButtons.forEach(btn => btn.addEventListener('click', closePopover));

    // Close on outside click (but not if clicking on toggle button)
    document.addEventListener('click', e => {
      var isToggleButton = Array.from(toggleButtons).some(btn => btn.contains(e.target));
      if (!popover.contains(e.target) && !isToggleButton && !popover.classList.contains('tw-hidden')) {
        closePopover();
      }
    });

    // Close on ESC - enhanced to work from anywhere
    var handleEscape = e => {
      if (e.key === 'Escape' && !popover.classList.contains('tw-hidden')) {
        e.preventDefault();
        e.stopPropagation();
        closePopover();
      }
    };

    // Attach Escape handler to toggle buttons and popover
    toggleButtons.forEach(btn => {
      btn.addEventListener('keydown', handleEscape);
    });
    popover.addEventListener('keydown', handleEscape);
  });

  // =========================
  // ACCORDIONS
  // =========================
  var accordions = root.querySelectorAll('[data-accordion]');
  accordions.forEach(acc => {
    if (acc.dataset._accordionAttached) return;
    acc.dataset._accordionAttached = true;
    var buttons = acc.querySelectorAll('[data-accordion-target]');
    buttons.forEach(btn => {
      var panel = document.getElementById(btn.dataset.accordionTarget);
      if (!panel) return; // Safety check

      // Find the parent accordion item that contains both button and panel
      // This works for any accordion structure (faq-accordion-item, footer-menu, etc.)
      var accordionItem = btn.parentElement;
      // Traverse up until we find the parent that contains the panel, or reach the accordion container
      while (accordionItem && accordionItem !== acc) {
        if (accordionItem.contains(panel)) {
          break; // Found the parent that contains both button and panel
        }
        accordionItem = accordionItem.parentElement;
      }
      // Ensure we have a valid accordion item (not the accordion container itself)
      if (!accordionItem || accordionItem === acc) {
        accordionItem = null;
      }
      btn.addEventListener('click', () => {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        panel.hidden = expanded;

        // Toggle active class on accordion item for CSS styling
        // Works globally for any accordion type
        if (accordionItem) {
          if (!expanded) {
            accordionItem.classList.add('is-active');
          } else {
            accordionItem.classList.remove('is-active');
          }
        }
      });
    });

    // // Open first FAQ accordion item on page load
    // const isFaqAccordion = acc.closest('[data-accordion]');

    // if (isFaqAccordion) {
    // 	const firstItem = isFaqAccordion.querySelector('.faq-section__accordion-item:first-child');
    // 	if (firstItem) {
    // 		const firstButton = firstItem.querySelector('[data-accordion-target]');
    // 		const firstPanel = firstItem.querySelector('.faq-section__accordion-panel');
    // 		if (firstButton && firstPanel) {
    // 			firstButton.setAttribute('aria-expanded', 'true');
    // 			firstPanel.hidden = false;
    // 			firstItem.classList.add('is-active');
    // 		}
    // 	}
    // }
  });

  // =========================
  // TABS (HORIZONTAL & VERTICAL)
  // =========================
  var tabLists = root.querySelectorAll('[data-tab-list]');
  tabLists.forEach(list => {
    if (list.dataset._tabAttached) return;
    list.dataset._tabAttached = true;
    var isTabSlide = list.hasAttribute('data-tab-slide');
    var tabs = list.querySelectorAll('[data-tab]');
    var orientation = list.dataset.tabOrientation || 'horizontal';
    var parentSection = list.closest('[data-tabs-section]');
    var tabContents = [...parentSection.querySelectorAll('[data-tab-content]')];
    if (!parentSection || tabContents.length <= 0) return;
    tabs.forEach((tab, index) => {
      var panelId = tab.dataset.tabTarget;
      tab.addEventListener('click', () => {
        tabs.forEach(t => {
          t.setAttribute('aria-selected', 'false');
          if (t.classList.contains('active')) {
            t.classList.remove('active');
          }
          tabContents.forEach(panel => {
            panel.classList.add('tw-hidden');
          });
          // Generic: Remove any --active modifier class
          Array.from(t.classList).forEach(cls => {
            if (cls.includes('--active')) {
              t.classList.remove(cls);
            }
          });
        });
        // Set active tab
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active');
        var swiperEl = tab.closest('carousel-swiper');
        if (swiperEl && isTabSlide) {
          if (swiperEl.swiper) {
            swiperEl.swiper.slideTo(index);
          }
        }
        var activePanel = tabContents.filter(panel => panel.id === panelId);
        activePanel.forEach(panel => {
          panel.classList.remove('tw-hidden');
        });
        // Generic: Add --active modifier class
        // Find base class name and add --active variant
        Array.from(tab.classList).forEach(cls => {
          if (cls.includes('__tab-button') && !cls.includes('--')) {
            tab.classList.add(cls + '--active');
          }
        });
      });
      tab.addEventListener('keydown', e => {
        var index = Array.from(tabs).indexOf(tab);
        if (orientation === 'horizontal') {
          if (e.key === 'ArrowRight') index++;else if (e.key === 'ArrowLeft') index--;
        } else {
          if (e.key === 'ArrowDown') index++;else if (e.key === 'ArrowUp') index--;
        }
        if (index < 0) index = tabs.length - 1;
        if (index >= tabs.length) index = 0;
        tabs[index].focus();
      });
    });
  });
  console.log('UI events attached');
}

// ------------------------------
// INIT FUNCTION
// ------------------------------
function initUIComponents() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  attachUIEvents(root);
}

/***/ }),

/***/ "./js/components/uniform-height.js":
/*!*****************************************!*\
  !*** ./js/components/uniform-height.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var uniformHeight = () => {
  var cardSelector = '.column-card, .multicolumn-card, .column-card-block, .content-tab';
  var apply = () => {
    document.querySelectorAll('[data-uniform-height]').forEach(container => {
      var isCarousel = container.classList.contains('swiper-wrapper');
      var isDesktop = window.innerWidth >= 768;
      var applyBody = container.getAttribute('data-uniform-body') !== 'false';

      // For grid: only apply at 768px+, for carousel: apply always
      if (!isCarousel && !isDesktop) {
        container.querySelectorAll(cardSelector).forEach(card => {
          var sub = card.querySelector('[class*="__subheading"]');
          var body = card.querySelector('[class*="__text-"], .rich-text');
          if (sub) sub.style.minHeight = '';
          if (body) body.style.minHeight = '';
        });
        return;
      }
      var cards = container.querySelectorAll(cardSelector);
      if (!cards.length) return;
      var subheadings = [];
      var bodies = [];
      cards.forEach(card => {
        var sub = card.querySelector('[class*="__subheading"]');
        var body = card.querySelector('[class*="__text-"], .rich-text');
        if (sub) {
          sub.style.minHeight = '';
          subheadings.push(sub);
        }
        if (applyBody && body) {
          body.style.minHeight = '';
          bodies.push(body);
        }
      });
      requestAnimationFrame(() => {
        if (subheadings.length) {
          var maxSubH = Math.max(...subheadings.map(el => el.offsetHeight));
          subheadings.forEach(el => el.style.minHeight = maxSubH + 'px');
        }
        if (applyBody && bodies.length) {
          var maxBodyH = Math.max(...bodies.map(el => el.offsetHeight));
          bodies.forEach(el => el.style.minHeight = maxBodyH + 'px');
        }
      });
    });
  };
  var init = () => {
    apply();
    window.addEventListener('resize', apply);

    // Listen for tab changes (event delegation)
    document.addEventListener('click', e => {
      var tab = e.target.closest('[data-tab], [role="tab"], .tab-button, .tabs__button');
      if (tab) setTimeout(apply, 10);
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('migrationComplete', apply);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('tabChange', apply);
  if (document.readyState !== 'loading') init();
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (uniformHeight);

/***/ }),

/***/ "./js/components/video.js":
/*!********************************!*\
  !*** ./js/components/video.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Video.js Player Custom Element
 * Initializes video.js players for CDN video sources
 */
class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.player = null;
    this.contentOverlayClickHandler = null;
    this.overlayImageKeyHandler = null;
    this.mobileAspectRatio = null;
    this.desktopAspectRatio = null;
    this.resizeHandler = null;
    this.mediaQueryHandler = null;
    this.fill = null;
    // Breakpoint matches Tailwind config: md-small (768px)
    this.breakpoint = 768;
    this.mediaQuery = window.matchMedia("(min-width: ".concat(this.breakpoint, "px)"));
  }
  connectedCallback() {
    // Get settings from script tag or data attributes
    var settingsScript = this.querySelector('script[type="application/json"]');
    var settings = settingsScript ? JSON.parse(settingsScript.textContent) : {};

    // Get options from data attributes (string values) or settings (boolean values)
    var getBooleanAttribute = attr => {
      var dataAttr = this.getAttribute(attr);
      if (dataAttr !== null) {
        return dataAttr === 'true';
      }
      return settings[attr.replace('data-', '')] !== undefined ? settings[attr.replace('data-', '')] : undefined;
    };
    var getStringAttribute = attr => {
      var dataAttr = this.getAttribute(attr);
      if (dataAttr !== null) {
        return dataAttr;
      }
      return settings[attr.replace('data-', '')] !== undefined ? settings[attr.replace('data-', '')] : undefined;
    };

    // Get aspect ratios directly (already in Video.js format from schema)
    this.mobileAspectRatio = getStringAttribute('data-mobile-aspect-ratio');
    this.desktopAspectRatio = getStringAttribute('data-desktop-aspect-ratio');
    this.fill = getBooleanAttribute('data-fill');
    // Determine initial aspect ratio based on screen size (md-small breakpoint: 768px)
    var getAspectRatio = () => {
      return this.mediaQuery.matches ? this.desktopAspectRatio || this.mobileAspectRatio : this.mobileAspectRatio || this.desktopAspectRatio;
    };
    var options = {
      controls: getBooleanAttribute('data-controls') !== false,
      autoplay: getBooleanAttribute('data-autoplay') === true,
      loop: getBooleanAttribute('data-loop') === true,
      muted: getBooleanAttribute('data-muted') === true,
      aspectRatio: getAspectRatio()
    };

    // Find the video element
    var videoElement = this.querySelector('video');
    if (!videoElement) return;
    var playerId = videoElement.id;
    if (!playerId) return;

    // Initialize video.js player
    this.initializeVideo(playerId, videoElement, options);
  }
  initializeVideo(playerId, videoElement, options) {
    // Wait for videojs to be available (from vendors.js)
    var tryInit = () => {
      if (typeof window.videojs !== 'undefined') {
        var videoUrl = videoElement.getAttribute('data-video-url');

        // Add source element before initializing video.js
        if (videoUrl) {
          var source = document.createElement('source');
          source.setAttribute('src', videoUrl);
          source.setAttribute('type', 'video/mp4');
          videoElement.appendChild(source);
        }

        // Initialize video.js player
        var playerOptions = {
          controls: options.controls !== undefined ? options.controls : false,
          autoplay: options.autoplay !== undefined ? options.autoplay : false,
          loop: options.loop !== undefined ? options.loop : false,
          muted: options.muted !== undefined ? options.muted : false
        };
        if (playerOptions !== null && playerOptions !== void 0 && playerOptions.autoplay) {
          playerOptions.muted = true;
        }
        if (!playerOptions.controls) {
          playerOptions["controlBar"] = false;
        }
        // Use aspectRatio if provided, otherwise use responsive and fluid
        if (this.fill) {
          playerOptions.fill = true;
        } else if (options.aspectRatio) {
          playerOptions.aspectRatio = options.aspectRatio;
          playerOptions.fluid = true;
          playerOptions.responsive = true;
        }
        this.player = window.videojs(playerId, playerOptions);

        // Make the player focusable for keyboard navigation
        this.player.ready(() => {
          var playerEl = this.player.el();
          if (playerEl) {
            // Set tabindex to make player keyboard accessible
            playerEl.setAttribute('tabindex', '0');

            // Ensure the player can receive focus and has proper ARIA attributes
            if (playerEl.getAttribute('role') === null) {
              playerEl.setAttribute('role', 'application');
            }

            // Enable keyboard controls - Video.js handles keyboard events automatically
            // when the player element has focus. Keyboard shortcuts include:
            // - Space/Enter: Play/Pause
            // - Left/Right Arrow: Seek backward/forward (5 seconds by default)
            // - Up/Down Arrow: Volume up/down
            // - 0-9: Seek to percentage (0=0%, 1=10%, etc.)
            // - M: Mute/Unmute
            // - F: Toggle fullscreen
            // - Home/End: Seek to start/end

            // Configure SeekBar step seconds for keyboard navigation if controls are enabled
            // According to Video.js SeekBar docs: stepSeconds defaults to 5 seconds
            if (this.player.controls()) {
              var controlBar = this.player.getChild('controlBar');
              if (controlBar) {
                var progressControl = controlBar.getChild('progressControl');
                if (progressControl) {
                  var seekBar = progressControl.getChild('seekBar');
                  // SeekBar stepSeconds option controls keyboard seek increment
                  // Default is 5 seconds per arrow key press
                  if (seekBar && !seekBar.options) {
                    seekBar.options = {};
                  }
                  if (seekBar && seekBar.options && !seekBar.options.stepSeconds) {
                    seekBar.options.stepSeconds = 5; // 5 second increments for keyboard seeking
                  }
                }
              }
            }

            // Video.js automatically handles keyboard events (Enter/Space for play/pause)
            // We'll rely on the 'play' and 'playing' events which fire when keyboard controls are used
            // No need to intercept keyboard events - Video.js handles them and fires player events
            // Video.js natively supports: Space/Enter (play/pause), Arrow keys (seek/volume), M (mute), F (fullscreen)
          }

          // iOS/Mobile autoplay fix: trigger play in ready callback
          // Mobile browsers require muted + playsinline + programmatic play()
          if (options.autoplay && this.player) {
            this.player.muted(true);
            var playPromise = this.player.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Autoplay was prevented, show play button overlay
                var contentOverlay = this.querySelector('.video-section__content');
                if (contentOverlay) {
                  contentOverlay.style.display = 'flex';
                }
              });
            }
          }
        });

        // Add event listener for pause event
        this.player.on('pause', () => {
          this.handlePause();
        });

        // Add event listener for play event (fires when play() is called, including from keyboard)
        // This will fire when user presses Enter or Space to play
        this.player.on('play', () => {
          this.handlePlay();
        });

        // Add event listener for playing event (fires when video actually starts playing)
        // This is a backup to ensure overlay is hidden when playback starts
        this.player.on('playing', () => {
          var contentOverlay = this.querySelector('.video-section__content');
          if (contentOverlay) {
            contentOverlay.style.display = 'none';
          }
        });

        // Also listen for useractive event - fires when user interacts (including keyboard)
        // This helps ensure overlay is hidden on any user interaction
        this.player.on('useractive', () => {
          if (this.player && !this.player.paused()) {
            var _contentOverlay = this.querySelector('.video-section__content');
            if (_contentOverlay) {
              _contentOverlay.style.display = 'none';
            }
          }
        });

        // Handle responsive aspect ratio changes
        if (this.mobileAspectRatio && this.desktopAspectRatio) {
          var resizeTimeout;
          var handleResize = () => {
            var newAspectRatio = this.mediaQuery.matches ? this.desktopAspectRatio || this.mobileAspectRatio : this.mobileAspectRatio || this.desktopAspectRatio;
            if (this.player && this.player.aspectRatio() !== newAspectRatio) {
              this.player.aspectRatio(newAspectRatio);
            }
          };

          // Use matchMedia listener for more reliable breakpoint detection (matches Tailwind md-small: 768px)
          this.mediaQueryHandler = handleResize;
          this.mediaQuery.addEventListener('change', this.mediaQueryHandler);

          // Also handle window resize with debounce as fallback
          this.resizeHandler = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(handleResize, 150);
          };
          window.addEventListener('resize', this.resizeHandler);
        }

        // Set initial state of content overlay and add click handler
        var contentOverlay = this.querySelector('.video-section__content');
        if (contentOverlay) {
          // Show overlay by default
          contentOverlay.style.display = 'flex';

          // Add click handler to play video
          contentOverlay.style.cursor = 'pointer';
          this.contentOverlayClickHandler = () => {
            if (this.player) {
              this.player.play();
            }
          };
          contentOverlay.addEventListener('click', this.contentOverlayClickHandler);

          // Add keyboard handler for Enter/Space on the image (or any focusable element in overlay)
          var overlayImage = contentOverlay.querySelector('img[tabindex]');
          if (overlayImage) {
            this.overlayImageKeyHandler = e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                if (this.player) {
                  this.player.play();
                  // Move focus to the video player element after playing
                  var playerEl = this.player.el();
                  if (playerEl) {
                    // Use setTimeout to ensure play() has been processed
                    setTimeout(() => {
                      playerEl.focus();
                    }, 100);
                  }
                }
              }
            };
            overlayImage.addEventListener('keydown', this.overlayImageKeyHandler);
          }
        }
      } else {
        // Retry after a short delay if vendors.js hasn't loaded yet
        setTimeout(tryInit, 100);
      }
    };

    // Start initialization
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryInit);
    } else {
      tryInit();
    }
  }
  handlePause() {
    // Handle pause event
    // This can be customized to show/hide content, trigger animations, etc.
    var contentOverlay = this.querySelector('.video-section__content');
    if (contentOverlay) {
      // Show content overlay when video is paused
      contentOverlay.style.display = 'flex';
    }

    // Dispatch custom event for external listeners
    this.dispatchEvent(new CustomEvent('video-pause', {
      detail: {
        player: this.player
      }
    }));
  }
  handlePlay() {
    // Handle play event
    var contentOverlay = this.querySelector('.video-section__content');
    if (contentOverlay) {
      // Hide content overlay when video is playing
      contentOverlay.style.display = 'none';
    }

    // Dispatch custom event for external listeners
    this.dispatchEvent(new CustomEvent('video-play', {
      detail: {
        player: this.player
      }
    }));
  }
  disconnectedCallback() {
    // Clean up video.js player when element is removed
    if (this.player) {
      // Remove event listeners
      this.player.off('pause');
      this.player.off('play');
      this.player.dispose();
      this.player = null;
    }

    // Remove resize handler and media query listener
    if (this.mediaQuery && this.mediaQueryHandler) {
      this.mediaQuery.removeEventListener('change', this.mediaQueryHandler);
      this.mediaQueryHandler = null;
    }
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }

    // Remove content overlay click handler and keyboard handler
    var contentOverlay = this.querySelector('.video-section__content');
    if (contentOverlay) {
      if (this.contentOverlayClickHandler) {
        contentOverlay.removeEventListener('click', this.contentOverlayClickHandler);
        this.contentOverlayClickHandler = null;
      }
      var overlayImage = contentOverlay.querySelector('img[tabindex]');
      if (overlayImage && this.overlayImageKeyHandler) {
        overlayImage.removeEventListener('keydown', this.overlayImageKeyHandler);
        this.overlayImageKeyHandler = null;
      }
    }
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VideoPlayer);

/***/ }),

/***/ "./js/sections/global.js":
/*!*******************************!*\
  !*** ./js/sections/global.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var JsComponents_carousel_swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/carousel-swiper */ "./js/components/carousel-swiper.js");
/* harmony import */ var _multicolumn_vertical_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicolumn-vertical.js */ "./js/sections/multicolumn-vertical.js");
/* harmony import */ var JsComponents_autoplay_text_wrapper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/autoplay-text-wrapper.js */ "./js/components/autoplay-text-wrapper.js");
/* harmony import */ var video_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! video.js */ "./node_modules/video.js/dist/video.es.js");
/* harmony import */ var JsComponents_video_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! JsComponents/video.js */ "./js/components/video.js");
/* harmony import */ var JsComponents_pdf_viewer_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! JsComponents/pdf-viewer.js */ "./js/components/pdf-viewer.js");
/* harmony import */ var JsComponents_ui_components_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! JsComponents/ui-components.js */ "./js/components/ui-components.js");
/* harmony import */ var JsComponents_header_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! JsComponents/header.js */ "./js/components/header.js");
/* harmony import */ var JsComponents_migrate_section_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! JsComponents/migrate-section.js */ "./js/components/migrate-section.js");
/* harmony import */ var JsComponents_stock_info_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! JsComponents/stock-info.js */ "./js/components/stock-info.js");
/* harmony import */ var JsComponents_scroll_tab_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! JsComponents/scroll-tab.js */ "./js/components/scroll-tab.js");
/* harmony import */ var JsComponents_stepped_form_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! JsComponents/stepped-form.js */ "./js/components/stepped-form.js");
/* harmony import */ var JsComponents_form_validation_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! JsComponents/form-validation.js */ "./js/components/form-validation.js");
/* harmony import */ var JsComponents_table_scrollbar_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! JsComponents/table-scrollbar.js */ "./js/components/table-scrollbar.js");
/* harmony import */ var JsComponents_financial_table_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! JsComponents/financial-table.js */ "./js/components/financial-table.js");
/* harmony import */ var JsComponents_uniform_height_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! JsComponents/uniform-height.js */ "./js/components/uniform-height.js");
//global imports here
















// Make videojs available globally
window.videojs = video_js__WEBPACK_IMPORTED_MODULE_3__["default"];
document.addEventListener('DOMContentLoaded', () => {
  (0,JsComponents_stock_info_js__WEBPACK_IMPORTED_MODULE_9__.updateAllStockfields)();
  (0,JsComponents_migrate_section_js__WEBPACK_IMPORTED_MODULE_8__.appendSection)();
  (0,JsComponents_migrate_section_js__WEBPACK_IMPORTED_MODULE_8__["default"])();
  customElements.define('carousel-swiper', JsComponents_carousel_swiper__WEBPACK_IMPORTED_MODULE_0__["default"]);
  customElements.define('video-player', JsComponents_video_js__WEBPACK_IMPORTED_MODULE_4__["default"]);
  customElements.define('pdf-viewer', JsComponents_pdf_viewer_js__WEBPACK_IMPORTED_MODULE_5__["default"]);
  (0,_multicolumn_vertical_js__WEBPACK_IMPORTED_MODULE_1__["default"])();
  (0,JsComponents_autoplay_text_wrapper_js__WEBPACK_IMPORTED_MODULE_2__["default"])();
  (0,JsComponents_ui_components_js__WEBPACK_IMPORTED_MODULE_6__.initUIComponents)();
  (0,JsComponents_header_js__WEBPACK_IMPORTED_MODULE_7__["default"])();
  (0,JsComponents_scroll_tab_js__WEBPACK_IMPORTED_MODULE_10__["default"])();
  (0,JsComponents_stepped_form_js__WEBPACK_IMPORTED_MODULE_11__["default"])();
  (0,JsComponents_form_validation_js__WEBPACK_IMPORTED_MODULE_12__["default"])();
  (0,JsComponents_table_scrollbar_js__WEBPACK_IMPORTED_MODULE_13__["default"])();
  (0,JsComponents_financial_table_js__WEBPACK_IMPORTED_MODULE_14__["default"])();
  (0,JsComponents_uniform_height_js__WEBPACK_IMPORTED_MODULE_15__["default"])();
});

// Re-init megamenu in Shopify theme editor when header or megamenu sections reload
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    (0,JsComponents_header_js__WEBPACK_IMPORTED_MODULE_7__["default"])(event.target);
  });
}

/***/ }),

/***/ "./js/sections/multicolumn-vertical.js":
/*!*********************************************!*\
  !*** ./js/sections/multicolumn-vertical.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });

var multicolumnVertical = () => {
  // Carousel is handled by the carousel-swiper custom element
  // No additional initialization needed
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (multicolumnVertical);

/***/ }),

/***/ "?34aa":
/*!******************************!*\
  !*** min-document (ignored) ***!
  \******************************/
/***/ (() => {

/* (ignored) */

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "./" + chunkId + ".js?" + "f0a9fac7a3cc9a8c5917" + "";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "shoptrade-Shopify-Development:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript && document.currentScript.tagName.toUpperCase() === 'SCRIPT')
/******/ 				scriptUrl = document.currentScript.src;
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) {
/******/ 					var i = scripts.length - 1;
/******/ 					while (i > -1 && (!scriptUrl || !/^http(s?):/.test(scriptUrl))) scriptUrl = scripts[i--].src;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/^blob:/, "").replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		__webpack_require__.b = (typeof document !== 'undefined' && document.baseURI) || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"global": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./js/sections/global.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;